// @ts-nocheck
// This is a UI component showcase/demo page - TypeScript checking disabled
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  // Layout & Navigation
  Breadcrumbs,
  Pagination,
  Stepper,
  Divider,

  // Forms & Inputs
  Button, Input, Checkbox, Radio, Switch, Textarea,  FileUpload, Select,

  // Data Display
  Badge, Card, CardHeader, Avatar, AvatarGroup,
  Chip, Rating, Timeline, CodeBlock, Kbd,
  Table, TableHead, TableBody, TableRow, TableHeader, TableCell,
  StatCard,

  // Feedback
  Alert, ToastContainer,
  LoadingScreen, EmptyState,
  Skeleton, SkeletonCard, ProgressBar, CircularProgress,

  // Overlays
  Modal, ConfirmationModal, Tooltip, Dropdown, DropdownTrigger,
  DropdownContent, DropdownItem, DropdownSeparator, Popover,
  Drawer, Accordion, AccordionItem, AccordionTrigger, AccordionContent,

  // Advanced
   CopyButton
} from '@azyntor-labs/nexus-ui';

import {
  Home, ChevronRight, Settings, User, Star, Heart,
  Download, Upload, CheckCircle, AlertCircle, Info, Zap,
  Menu, X, FileText, Database, Bell, Navigation2, Layers, Sparkles, ExternalLink,
  Play, Send, Save, Plus, Check, Mail, Search, Trash2, Edit, Eye,
  Github, Twitter, Facebook, Linkedin, Instagram, Youtube, ArrowRight, ShoppingCart,
  Calendar, Clock, Filter, MoreVertical, Share2, Lock, Phone, EyeOff,
  CreditCard, MapPin, Globe, Shield, AtSign
} from 'lucide-react';

export const NewComponentShowcase = () => {
  // Navigation state
  const [activeCategory, setActiveCategory] = useState('forms');
  const [activeComponent, setActiveComponent] = useState<string | null>(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Component states
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [radioValue, setRadioValue] = useState('option1');
  const [switchChecked, setSwitchChecked] = useState(false);
  const [switch1, setSwitch1] = useState(false);
  const [switch2, setSwitch2] = useState(true);
  const [switch3, setSwitch3] = useState(false);
  const [switch4, setSwitch4] = useState(true);
  const [switch5, setSwitch5] = useState(false);
  const [_sliderValue, _setSliderValue] = useState(50);
  const [_sliderValue2, _setSliderValue2] = useState(75);
  const [_sliderValue3, _setSliderValue3] = useState(30);
  const [_sliderValue4, _setSliderValue4] = useState(60);
  const [_sliderValue5, _setSliderValue5] = useState(40);
  const [_textareaValue, _setTextareaValue] = useState('');
  const [textareaValue2, setTextareaValue2] = useState('This is a sample text with character count enabled.');
  const [ratingValue, setRatingValue] = useState(3.5);
  const [currentPage, setCurrentPage] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [stepperActive, setStepperActive] = useState(1);

  // Modal states
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  // Toast state
  const [toasts, setToasts] = useState<Array<{
    id: string;
    type: 'success' | 'error' | 'warning' | 'info';
    title: string;
    message?: string;
  }>>([]);
  const [toastPosition, setToastPosition] = useState<'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center'>('top-right');

  // Loading screen state
  const [loadingVariant, setLoadingVariant] = useState<string | null>(null);

  // Select state
  const [selectValue, setSelectValue] = useState('');

  // Toast functions
  const addToast = (type: 'success' | 'error' | 'warning' | 'info', title: string, message: string) => {
    const id = `toast-${Date.now()}`;
    setToasts(prev => [...prev, { id, type, title, message }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 5000);
  };

  // Category definitions
  const categories = [
    { id: 'forms', label: 'Forms & Inputs', icon: FileText },
    { id: 'display', label: 'Data Display', icon: Database },
    { id: 'feedback', label: 'Feedback', icon: Bell },
    { id: 'navigation', label: 'Navigation', icon: Navigation2 },
    { id: 'overlays', label: 'Overlays', icon: Layers },
    { id: 'advanced', label: 'Advanced', icon: Sparkles },
    { id: 'pages', label: 'Full Pages', icon: ExternalLink }
  ];

  // Component lists per category with IDs
  const componentsByCategory: Record<string, Array<{ name: string; id: string }>> = {
    forms: [
      { name: 'Button', id: 'button' },
      { name: 'Input', id: 'input' },
      { name: 'Checkbox, Radio & Switch', id: 'checkbox-radio-switch' },
      { name: 'Textarea', id: 'textarea' },
      { name: 'Slider', id: 'slider' },
      { name: 'File Upload', id: 'file-upload' },
      { name: 'Select', id: 'select' }
    ],
    display: [
      { name: 'Badges', id: 'badges' },
      { name: 'Avatar', id: 'avatar' },
      { name: 'Chips / Tags', id: 'chips' },
      { name: 'Rating', id: 'rating' },
      { name: 'Timeline', id: 'timeline' },
      { name: 'Code Block', id: 'code-block' },
      { name: 'Keyboard Shortcuts', id: 'kbd' },
      { name: 'Copy Button', id: 'copy-button' },
      { name: 'Data Table', id: 'table' },
      { name: 'Stat Cards', id: 'stat-cards' }
    ],
    feedback: [
      { name: 'Alerts', id: 'alerts' },
      { name: 'Progress Indicators', id: 'progress' },
      { name: 'Skeleton Loaders', id: 'skeleton' },
      { name: 'Empty State', id: 'empty-state' },
      { name: 'Toast Notifications', id: 'toast' },
      { name: 'Loading Screen', id: 'loading-screen' }
    ],
    navigation: [
      { name: 'Pagination', id: 'pagination' },
      { name: 'Stepper', id: 'stepper' },
      { name: 'Divider', id: 'divider' }
    ],
    overlays: [
      { name: 'Tooltip', id: 'tooltip' },
      { name: 'Dropdown', id: 'dropdown' },
      { name: 'Popover', id: 'popover' },
      { name: 'Drawer', id: 'drawer' },
      { name: 'Accordion', id: 'accordion' },
      { name: 'Modals', id: 'modals' }
    ],
    advanced: [
      { name: 'Carousel', id: 'carousel' },
      { name: 'Card Variants', id: 'card-variants' }
    ],
    pages: []
  };

  // Set active component (now shows only that component)
  const selectComponent = (id: string) => {
    setActiveComponent(id);
    // Scroll to top of content area
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Scroll to a specific component
  const scrollToComponent = (id: string) => {
    setActiveComponent(id);
    // Scroll to top of content area
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="min-h-screen bg-[#0d0d12] p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-8">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-teal-400 to-cyan-500 bg-clip-text text-transparent mb-2">
              Complete Component Library
            </h1>
            <p className="text-gray-400">
              All 39 UI components - 15 existing + 24 new components with full interactivity
            </p>
          </div>
          <Link to="/dashboard">
            <Button variant="outline" size="md">
              Back to Dashboard
            </Button>
          </Link>
        </div>

        <Breadcrumbs
          items={[
            { label: 'Home', href: '/dashboard', icon: Home },
            { label: 'Components', href: '/showcase' },
            { label: 'Showcase' }
          ]}
        />
      </div>

      {/* Category Header */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-[#12121a]/60 backdrop-blur-sm border border-white/[0.06] rounded-lg p-4">
          <div className="flex items-center gap-4 overflow-x-auto">
            {categories.map((category) => {
              const Icon = category.icon;
              return (
                <button
                  key={category.id}
                  onClick={() => {
                    setActiveCategory(category.id);
                    setActiveComponent(null);
                  }}
                  className={`
                    flex items-center gap-2 px-4 py-2 rounded-lg transition-all whitespace-nowrap
                    ${activeCategory === category.id
                      ? 'bg-gradient-to-r from-teal-500/20 to-cyan-500/20 border border-teal-500/30 text-teal-400'
                      : 'text-gray-400 hover:text-gray-200 hover:bg-white/[0.03]'
                    }
                  `}
                >
                  <Icon className="w-4 h-4" />
                  <span className="font-medium">{category.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Main Content with Sidebar */}
      <div className="max-w-7xl mx-auto">
        <div className="flex gap-6">
          {/* Sidebar */}
          {activeCategory !== 'pages' && (
            <div className={`${sidebarOpen ? 'w-64' : 'w-0'} transition-all duration-300 overflow-hidden flex-shrink-0`}>
              <div className="bg-[#12121a]/60 backdrop-blur-sm border border-white/[0.06] rounded-lg p-4 sticky top-8">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-sm font-semibold text-gray-300">Components</h3>
                  <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="text-gray-400 hover:text-gray-200"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
                <div className="space-y-1">
                  {/* Show All Button */}
                  <button
                    onClick={() => setActiveComponent(null)}
                    className={`
                      w-full text-left px-3 py-2 rounded-lg text-sm transition-all font-semibold
                      ${!activeComponent
                        ? 'bg-gradient-to-r from-teal-500/20 to-cyan-500/20 border border-teal-500/30 text-teal-400'
                        : 'text-gray-400 hover:text-gray-200 hover:bg-white/[0.03]'
                      }
                    `}
                  >
                    Show All Components
                  </button>

                  <div className="border-t border-white/[0.06] my-2"></div>

                  {componentsByCategory[activeCategory]?.map((component) => (
                    <button
                      key={component.id}
                      onClick={() => selectComponent(component.id)}
                      className={`
                        w-full text-left px-3 py-2 rounded-lg text-sm transition-all
                        ${activeComponent === component.id
                          ? 'bg-teal-500/10 text-teal-400 border border-teal-500/20'
                          : 'text-gray-400 hover:text-gray-200 hover:bg-white/[0.03]'
                        }
                      `}
                    >
                      {component.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {!sidebarOpen && activeCategory !== 'pages' && (
            <button
              onClick={() => setSidebarOpen(true)}
              className="fixed left-8 top-1/2 -translate-y-1/2 bg-[#12121a]/80 backdrop-blur-sm border border-white/[0.06] rounded-lg p-3 hover:bg-[#12121a] transition-all z-10"
            >
              <Menu className="w-5 h-5 text-gray-400" />
            </button>
          )}

          {/* Content Area */}
          <div className="flex-1 min-w-0">
            {activeCategory === 'forms' && (
            <div className="space-y-8">
              {/* Buttons */}
              {(!activeComponent || activeComponent === 'button') && (
              <Card id="button">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Buttons - Complete Showcase</h3>
                  <p className="text-sm text-gray-400">41 variants × 5 sizes × 4 shapes + Icons + States = 200+ combinations</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Variants */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Basic Variants (21)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Primary</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="primary" size="sm">Small</Button>
                          <Button variant="primary" size="md">Medium</Button>
                          <Button variant="primary" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Secondary</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="secondary" size="sm">Small</Button>
                          <Button variant="secondary" size="md">Medium</Button>
                          <Button variant="secondary" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Tertiary</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="tertiary" size="sm">Small</Button>
                          <Button variant="tertiary" size="md">Medium</Button>
                          <Button variant="tertiary" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Success</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="success" size="sm">Small</Button>
                          <Button variant="success" size="md">Medium</Button>
                          <Button variant="success" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Danger</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="danger" size="sm">Small</Button>
                          <Button variant="danger" size="md">Medium</Button>
                          <Button variant="danger" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Warning</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="warning" size="sm">Small</Button>
                          <Button variant="warning" size="md">Medium</Button>
                          <Button variant="warning" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Info</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="info" size="sm">Small</Button>
                          <Button variant="info" size="md">Medium</Button>
                          <Button variant="info" size="lg">Large</Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Outline Variants */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Outline Variants (18)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Outline</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="outline" size="sm">Small</Button>
                          <Button variant="outline" size="md">Medium</Button>
                          <Button variant="outline" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Outline Primary</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="outline-primary" size="sm">Small</Button>
                          <Button variant="outline-primary" size="md">Medium</Button>
                          <Button variant="outline-primary" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Outline Success</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="outline-success" size="sm">Small</Button>
                          <Button variant="outline-success" size="md">Medium</Button>
                          <Button variant="outline-success" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Outline Danger</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="outline-danger" size="sm">Small</Button>
                          <Button variant="outline-danger" size="md">Medium</Button>
                          <Button variant="outline-danger" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Outline Warning</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="outline-warning" size="sm">Small</Button>
                          <Button variant="outline-warning" size="md">Medium</Button>
                          <Button variant="outline-warning" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Outline Info</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="outline-info" size="sm">Small</Button>
                          <Button variant="outline-info" size="md">Medium</Button>
                          <Button variant="outline-info" size="lg">Large</Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Ghost Variants */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Ghost Variants (18)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Ghost</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="ghost" size="sm">Small</Button>
                          <Button variant="ghost" size="md">Medium</Button>
                          <Button variant="ghost" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Ghost Primary</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="ghost-primary" size="sm">Small</Button>
                          <Button variant="ghost-primary" size="md">Medium</Button>
                          <Button variant="ghost-primary" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Ghost Success</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="ghost-success" size="sm">Small</Button>
                          <Button variant="ghost-success" size="md">Medium</Button>
                          <Button variant="ghost-success" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Ghost Danger</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="ghost-danger" size="sm">Small</Button>
                          <Button variant="ghost-danger" size="md">Medium</Button>
                          <Button variant="ghost-danger" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Ghost Warning</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="ghost-warning" size="sm">Small</Button>
                          <Button variant="ghost-warning" size="md">Medium</Button>
                          <Button variant="ghost-warning" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Ghost Info</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="ghost-info" size="sm">Small</Button>
                          <Button variant="ghost-info" size="md">Medium</Button>
                          <Button variant="ghost-info" size="lg">Large</Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Gradient Variants */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Gradient Variants (21)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Primary</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-primary" size="sm">Small</Button>
                          <Button variant="gradient-primary" size="md">Medium</Button>
                          <Button variant="gradient-primary" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Success</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-success" size="sm">Small</Button>
                          <Button variant="gradient-success" size="md">Medium</Button>
                          <Button variant="gradient-success" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Danger</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-danger" size="sm">Small</Button>
                          <Button variant="gradient-danger" size="md">Medium</Button>
                          <Button variant="gradient-danger" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Warning</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-warning" size="sm">Small</Button>
                          <Button variant="gradient-warning" size="md">Medium</Button>
                          <Button variant="gradient-warning" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Info</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-info" size="sm">Small</Button>
                          <Button variant="gradient-info" size="md">Medium</Button>
                          <Button variant="gradient-info" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Purple</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-purple" size="sm">Small</Button>
                          <Button variant="gradient-purple" size="md">Medium</Button>
                          <Button variant="gradient-purple" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Gradient Ocean</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="gradient-ocean" size="sm">Small</Button>
                          <Button variant="gradient-ocean" size="md">Medium</Button>
                          <Button variant="gradient-ocean" size="lg">Large</Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Special Effects */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Special Effects (21)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Glow</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="glow" size="sm">Small</Button>
                          <Button variant="glow" size="md">Medium</Button>
                          <Button variant="glow" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Neon</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="neon" size="sm">Small</Button>
                          <Button variant="neon" size="md">Medium</Button>
                          <Button variant="neon" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Glass</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="glass" size="sm">Small</Button>
                          <Button variant="glass" size="md">Medium</Button>
                          <Button variant="glass" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Shimmer</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="shimmer" size="sm">Small</Button>
                          <Button variant="shimmer" size="md">Medium</Button>
                          <Button variant="shimmer" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">3D</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="3d" size="sm">Small</Button>
                          <Button variant="3d" size="md">Medium</Button>
                          <Button variant="3d" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Animated</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="animated" size="sm">Small</Button>
                          <Button variant="animated" size="md">Medium</Button>
                          <Button variant="animated" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Pulse</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="pulse" size="sm">Small</Button>
                          <Button variant="pulse" size="md">Medium</Button>
                          <Button variant="pulse" size="lg">Large</Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* With Icons - Left Icon */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">With Icons - Left Icon (30)</h4>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      <Button variant="primary" leftIcon={<Play className="w-4 h-4" />}>Play</Button>
                      <Button variant="success" leftIcon={<Download className="w-4 h-4" />}>Download</Button>
                      <Button variant="info" leftIcon={<Upload className="w-4 h-4" />}>Upload</Button>
                      <Button variant="secondary" leftIcon={<Send className="w-4 h-4" />}>Send</Button>
                      <Button variant="warning" leftIcon={<Save className="w-4 h-4" />}>Save</Button>
                      <Button variant="primary" leftIcon={<Plus className="w-4 h-4" />}>Add New</Button>
                      <Button variant="success" leftIcon={<Check className="w-4 h-4" />}>Confirm</Button>
                      <Button variant="danger" leftIcon={<Trash2 className="w-4 h-4" />}>Delete</Button>
                      <Button variant="outline" leftIcon={<Edit className="w-4 h-4" />}>Edit</Button>
                      <Button variant="ghost" leftIcon={<Eye className="w-4 h-4" />}>View</Button>
                    </div>
                    <p className="text-xs text-gray-500 mt-2">Right Icon variants</p>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      <Button variant="primary" rightIcon={<ArrowRight className="w-4 h-4" />}>Next</Button>
                      <Button variant="success" rightIcon={<CheckCircle className="w-4 h-4" />}>Complete</Button>
                      <Button variant="info" rightIcon={<ExternalLink className="w-4 h-4" />}>Open</Button>
                      <Button variant="secondary" rightIcon={<ChevronRight className="w-4 h-4" />}>Continue</Button>
                      <Button variant="outline" rightIcon={<Download className="w-4 h-4" />}>Export</Button>
                      <Button variant="ghost" rightIcon={<Share2 className="w-4 h-4" />}>Share</Button>
                      <Button variant="gradient-primary" rightIcon={<Star className="w-4 h-4" />}>Favorite</Button>
                      <Button variant="gradient-success" rightIcon={<Heart className="w-4 h-4" />}>Like</Button>
                      <Button variant="gradient-info" rightIcon={<Mail className="w-4 h-4" />}>Email</Button>
                      <Button variant="gradient-warning" rightIcon={<Bell className="w-4 h-4" />}>Notify</Button>
                    </div>
                    <p className="text-xs text-gray-500 mt-2">Both Icons</p>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      <Button variant="primary" leftIcon={<User className="w-4 h-4" />} rightIcon={<ChevronRight className="w-4 h-4" />}>Profile</Button>
                      <Button variant="success" leftIcon={<CheckCircle className="w-4 h-4" />} rightIcon={<ArrowRight className="w-4 h-4" />}>Proceed</Button>
                      <Button variant="info" leftIcon={<Settings className="w-4 h-4" />} rightIcon={<ChevronRight className="w-4 h-4" />}>Settings</Button>
                      <Button variant="secondary" leftIcon={<Database className="w-4 h-4" />} rightIcon={<ArrowRight className="w-4 h-4" />}>Database</Button>
                      <Button variant="outline" leftIcon={<Search className="w-4 h-4" />} rightIcon={<Filter className="w-4 h-4" />}>Search</Button>
                      <Button variant="ghost" leftIcon={<Calendar className="w-4 h-4" />} rightIcon={<Clock className="w-4 h-4" />}>Schedule</Button>
                      <Button variant="gradient-primary" leftIcon={<Star className="w-4 h-4" />} rightIcon={<Plus className="w-4 h-4" />}>Add Star</Button>
                      <Button variant="gradient-success" leftIcon={<ShoppingCart className="w-4 h-4" />} rightIcon={<ArrowRight className="w-4 h-4" />}>Checkout</Button>
                      <Button variant="gradient-info" leftIcon={<Mail className="w-4 h-4" />} rightIcon={<Send className="w-4 h-4" />}>Send Email</Button>
                      <Button variant="gradient-ocean" leftIcon={<FileText className="w-4 h-4" />} rightIcon={<Download className="w-4 h-4" />}>Download</Button>
                    </div>
                  </div>

                  <Divider />

                  {/* Icon Only Buttons */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Icon Only Buttons (30)</h4>
                    <div className="space-y-3">
                      <p className="text-xs text-gray-500">Small Icons</p>
                      <div className="flex flex-wrap gap-2">
                        <Button variant="primary" size="sm" iconOnly><Play className="w-3 h-3" /></Button>
                        <Button variant="success" size="sm" iconOnly><Check className="w-3 h-3" /></Button>
                        <Button variant="danger" size="sm" iconOnly><X className="w-3 h-3" /></Button>
                        <Button variant="warning" size="sm" iconOnly><AlertCircle className="w-3 h-3" /></Button>
                        <Button variant="info" size="sm" iconOnly><Info className="w-3 h-3" /></Button>
                        <Button variant="outline" size="sm" iconOnly><Edit className="w-3 h-3" /></Button>
                        <Button variant="ghost" size="sm" iconOnly><Eye className="w-3 h-3" /></Button>
                        <Button variant="gradient-primary" size="sm" iconOnly><Star className="w-3 h-3" /></Button>
                        <Button variant="gradient-success" size="sm" iconOnly><Heart className="w-3 h-3" /></Button>
                        <Button variant="gradient-danger" size="sm" iconOnly><Trash2 className="w-3 h-3" /></Button>
                      </div>
                      <p className="text-xs text-gray-500">Medium Icons</p>
                      <div className="flex flex-wrap gap-2">
                        <Button variant="primary" size="md" iconOnly><Play className="w-4 h-4" /></Button>
                        <Button variant="success" size="md" iconOnly><Check className="w-4 h-4" /></Button>
                        <Button variant="danger" size="md" iconOnly><X className="w-4 h-4" /></Button>
                        <Button variant="warning" size="md" iconOnly><AlertCircle className="w-4 h-4" /></Button>
                        <Button variant="info" size="md" iconOnly><Info className="w-4 h-4" /></Button>
                        <Button variant="outline" size="md" iconOnly><Edit className="w-4 h-4" /></Button>
                        <Button variant="ghost" size="md" iconOnly><Eye className="w-4 h-4" /></Button>
                        <Button variant="gradient-primary" size="md" iconOnly><Star className="w-4 h-4" /></Button>
                        <Button variant="gradient-success" size="md" iconOnly><Heart className="w-4 h-4" /></Button>
                        <Button variant="gradient-danger" size="md" iconOnly><Trash2 className="w-4 h-4" /></Button>
                      </div>
                      <p className="text-xs text-gray-500">Large Icons</p>
                      <div className="flex flex-wrap gap-2">
                        <Button variant="primary" size="lg" iconOnly><Play className="w-5 h-5" /></Button>
                        <Button variant="success" size="lg" iconOnly><Check className="w-5 h-5" /></Button>
                        <Button variant="danger" size="lg" iconOnly><X className="w-5 h-5" /></Button>
                        <Button variant="warning" size="lg" iconOnly><AlertCircle className="w-5 h-5" /></Button>
                        <Button variant="info" size="lg" iconOnly><Info className="w-5 h-5" /></Button>
                        <Button variant="outline" size="lg" iconOnly><Edit className="w-5 h-5" /></Button>
                        <Button variant="ghost" size="lg" iconOnly><Eye className="w-5 h-5" /></Button>
                        <Button variant="gradient-primary" size="lg" iconOnly><Star className="w-5 h-5" /></Button>
                        <Button variant="gradient-success" size="lg" iconOnly><Heart className="w-5 h-5" /></Button>
                        <Button variant="gradient-danger" size="lg" iconOnly><Trash2 className="w-5 h-5" /></Button>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Different Shapes */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Different Shapes (20)</h4>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Rounded (Default)</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="primary" shape="rounded">Primary</Button>
                          <Button variant="success" shape="rounded">Success</Button>
                          <Button variant="danger" shape="rounded">Danger</Button>
                          <Button variant="outline" shape="rounded">Outline</Button>
                          <Button variant="gradient-primary" shape="rounded">Gradient</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Square</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="primary" shape="square">Primary</Button>
                          <Button variant="success" shape="square">Success</Button>
                          <Button variant="danger" shape="square">Danger</Button>
                          <Button variant="outline" shape="square">Outline</Button>
                          <Button variant="gradient-primary" shape="square">Gradient</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Pill</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="primary" shape="pill">Primary</Button>
                          <Button variant="success" shape="pill">Success</Button>
                          <Button variant="danger" shape="pill">Danger</Button>
                          <Button variant="outline" shape="pill">Outline</Button>
                          <Button variant="gradient-primary" shape="pill">Gradient</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Circle (Icon Only)</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="primary" shape="circle" iconOnly><Play className="w-4 h-4" /></Button>
                          <Button variant="success" shape="circle" iconOnly><Check className="w-4 h-4" /></Button>
                          <Button variant="danger" shape="circle" iconOnly><X className="w-4 h-4" /></Button>
                          <Button variant="outline" shape="circle" iconOnly><Edit className="w-4 h-4" /></Button>
                          <Button variant="gradient-primary" shape="circle" iconOnly><Star className="w-4 h-4" /></Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Social Media Buttons */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Social Media Buttons (6)</h4>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                      <Button variant="social-github" leftIcon={<Github className="w-4 h-4" />}>GitHub</Button>
                      <Button variant="social-twitter" leftIcon={<Twitter className="w-4 h-4" />}>Twitter</Button>
                      <Button variant="social-facebook" leftIcon={<Facebook className="w-4 h-4" />}>Facebook</Button>
                      <Button variant="social-linkedin" leftIcon={<Linkedin className="w-4 h-4" />}>LinkedIn</Button>
                      <Button variant="social-instagram" leftIcon={<Instagram className="w-4 h-4" />}>Instagram</Button>
                      <Button variant="social-youtube" leftIcon={<Youtube className="w-4 h-4" />}>YouTube</Button>
                    </div>
                  </div>

                  <Divider />

                  {/* Utility Variants */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Utility Variants (15)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Link Style</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="link" size="sm">Small Link</Button>
                          <Button variant="link" size="md">Medium Link</Button>
                          <Button variant="link" size="lg">Large Link</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Unstyled</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="unstyled" size="sm">Small</Button>
                          <Button variant="unstyled" size="md">Medium</Button>
                          <Button variant="unstyled" size="lg">Large</Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Icon Buttons</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="icon" size="sm" iconOnly><Settings className="w-3 h-3" /></Button>
                          <Button variant="icon" size="md" iconOnly><Settings className="w-4 h-4" /></Button>
                          <Button variant="icon" size="lg" iconOnly><Settings className="w-5 h-5" /></Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Menu Buttons</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="menu" size="sm" iconOnly><MoreVertical className="w-3 h-3" /></Button>
                          <Button variant="menu" size="md" iconOnly><MoreVertical className="w-4 h-4" /></Button>
                          <Button variant="menu" size="lg" iconOnly><MoreVertical className="w-5 h-5" /></Button>
                        </div>
                      </div>
                      <div className="space-y-3">
                        <p className="text-xs text-gray-500">Close Buttons</p>
                        <div className="flex flex-wrap gap-2">
                          <Button variant="close" size="sm" iconOnly><X className="w-3 h-3" /></Button>
                          <Button variant="close" size="md" iconOnly><X className="w-4 h-4" /></Button>
                          <Button variant="close" size="lg" iconOnly><X className="w-5 h-5" /></Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider />

                  {/* Loading States */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Loading States (5)</h4>
                    <div className="flex flex-wrap gap-3">
                      <Button variant="primary" loading>Loading Primary</Button>
                      <Button variant="success" loading>Loading Success</Button>
                      <Button variant="danger" loading>Loading Danger</Button>
                      <Button variant="outline" loading>Loading Outline</Button>
                      <Button variant="gradient-primary" loading>Loading Gradient</Button>
                    </div>
                  </div>

                  <Divider />

                  {/* Disabled States */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Disabled States (5)</h4>
                    <div className="flex flex-wrap gap-3">
                      <Button variant="primary" disabled>Disabled Primary</Button>
                      <Button variant="success" disabled>Disabled Success</Button>
                      <Button variant="danger" disabled>Disabled Danger</Button>
                      <Button variant="outline" disabled>Disabled Outline</Button>
                      <Button variant="gradient-primary" disabled>Disabled Gradient</Button>
                    </div>
                  </div>

                  <Divider />

                  {/* Full Width */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400 uppercase tracking-wider">Full Width Buttons (5)</h4>
                    <div className="space-y-2">
                      <Button variant="primary" fullWidth>Full Width Primary</Button>
                      <Button variant="success" fullWidth leftIcon={<CheckCircle className="w-4 h-4" />}>Full Width with Icon</Button>
                      <Button variant="gradient-primary" fullWidth>Full Width Gradient</Button>
                      <Button variant="outline" fullWidth>Full Width Outline</Button>
                      <Button variant="ghost" fullWidth>Full Width Ghost</Button>
                    </div>
                  </div>

                  {/* Summary */}
                  <div className="mt-6 p-4 bg-teal-500/10 border border-teal-500/20 rounded-lg">
                    <h5 className="text-sm font-semibold text-teal-400 mb-2">Summary</h5>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs text-gray-400">
                      <div>
                        <span className="text-white font-semibold">21</span> Basic Variants
                      </div>
                      <div>
                        <span className="text-white font-semibold">18</span> Outline Variants
                      </div>
                      <div>
                        <span className="text-white font-semibold">18</span> Ghost Variants
                      </div>
                      <div>
                        <span className="text-white font-semibold">21</span> Gradient Variants
                      </div>
                      <div>
                        <span className="text-white font-semibold">21</span> Special Effects
                      </div>
                      <div>
                        <span className="text-white font-semibold">30</span> Icon Combinations
                      </div>
                      <div>
                        <span className="text-white font-semibold">30</span> Icon Only
                      </div>
                      <div>
                        <span className="text-white font-semibold">20</span> Shape Variants
                      </div>
                      <div>
                        <span className="text-white font-semibold">6</span> Social Media
                      </div>
                      <div>
                        <span className="text-white font-semibold">15</span> Utility Variants
                      </div>
                      <div>
                        <span className="text-white font-semibold">5</span> Loading States
                      </div>
                      <div>
                        <span className="text-white font-semibold">5</span> Disabled States
                      </div>
                      <div>
                        <span className="text-white font-semibold">5</span> Full Width
                      </div>
                      <div className="col-span-2 md:col-span-4 mt-2 pt-2 border-t border-teal-500/20">
                        <span className="text-teal-400 font-bold text-base">215+ Total Button Combinations</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Input */}
              {(!activeComponent || activeComponent === 'input') && (
              <Card id="input">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Input - 210+ Variants</h3>
                  <p className="text-sm text-gray-400">Comprehensive input library with 43 variants, 5 sizes, 3 shapes, icons & more</p>
                </CardHeader>
                <div className="p-6 space-y-8">

                  {/* Basic Variants (24) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400">Basic Variants (24)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="default" size="sm" placeholder="Default Small" />
                      <Input variant="default" size="md" placeholder="Default Medium" />
                      <Input variant="default" size="lg" placeholder="Default Large" />
                      <Input variant="primary" size="sm" placeholder="Primary Small" />
                      <Input variant="primary" size="md" placeholder="Primary Medium" />
                      <Input variant="primary" size="lg" placeholder="Primary Large" />
                      <Input variant="secondary" size="sm" placeholder="Secondary Small" />
                      <Input variant="secondary" size="md" placeholder="Secondary Medium" />
                      <Input variant="secondary" size="lg" placeholder="Secondary Large" />
                      <Input variant="tertiary" size="sm" placeholder="Tertiary Small" />
                      <Input variant="tertiary" size="md" placeholder="Tertiary Medium" />
                      <Input variant="tertiary" size="lg" placeholder="Tertiary Large" />
                      <Input variant="danger" size="sm" placeholder="Danger Small" />
                      <Input variant="danger" size="md" placeholder="Danger Medium" />
                      <Input variant="danger" size="lg" placeholder="Danger Large" />
                      <Input variant="success" size="sm" placeholder="Success Small" />
                      <Input variant="success" size="md" placeholder="Success Medium" />
                      <Input variant="success" size="lg" placeholder="Success Large" />
                      <Input variant="warning" size="sm" placeholder="Warning Small" />
                      <Input variant="warning" size="md" placeholder="Warning Medium" />
                      <Input variant="warning" size="lg" placeholder="Warning Large" />
                      <Input variant="info" size="sm" placeholder="Info Small" />
                      <Input variant="info" size="md" placeholder="Info Medium" />
                      <Input variant="info" size="lg" placeholder="Info Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Outline Variants (18) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-cyan-400">Outline Variants (18)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="outline" size="sm" placeholder="Outline Small" />
                      <Input variant="outline" size="md" placeholder="Outline Medium" />
                      <Input variant="outline" size="lg" placeholder="Outline Large" />
                      <Input variant="outline-primary" size="sm" placeholder="Outline Primary Small" />
                      <Input variant="outline-primary" size="md" placeholder="Outline Primary Medium" />
                      <Input variant="outline-primary" size="lg" placeholder="Outline Primary Large" />
                      <Input variant="outline-danger" size="sm" placeholder="Outline Danger Small" />
                      <Input variant="outline-danger" size="md" placeholder="Outline Danger Medium" />
                      <Input variant="outline-danger" size="lg" placeholder="Outline Danger Large" />
                      <Input variant="outline-success" size="sm" placeholder="Outline Success Small" />
                      <Input variant="outline-success" size="md" placeholder="Outline Success Medium" />
                      <Input variant="outline-success" size="lg" placeholder="Outline Success Large" />
                      <Input variant="outline-warning" size="sm" placeholder="Outline Warning Small" />
                      <Input variant="outline-warning" size="md" placeholder="Outline Warning Medium" />
                      <Input variant="outline-warning" size="lg" placeholder="Outline Warning Large" />
                      <Input variant="outline-info" size="sm" placeholder="Outline Info Small" />
                      <Input variant="outline-info" size="md" placeholder="Outline Info Medium" />
                      <Input variant="outline-info" size="lg" placeholder="Outline Info Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Ghost Variants (18) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-purple-400">Ghost Variants (18)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="ghost" size="sm" placeholder="Ghost Small" />
                      <Input variant="ghost" size="md" placeholder="Ghost Medium" />
                      <Input variant="ghost" size="lg" placeholder="Ghost Large" />
                      <Input variant="ghost-primary" size="sm" placeholder="Ghost Primary Small" />
                      <Input variant="ghost-primary" size="md" placeholder="Ghost Primary Medium" />
                      <Input variant="ghost-primary" size="lg" placeholder="Ghost Primary Large" />
                      <Input variant="ghost-danger" size="sm" placeholder="Ghost Danger Small" />
                      <Input variant="ghost-danger" size="md" placeholder="Ghost Danger Medium" />
                      <Input variant="ghost-danger" size="lg" placeholder="Ghost Danger Large" />
                      <Input variant="ghost-success" size="sm" placeholder="Ghost Success Small" />
                      <Input variant="ghost-success" size="md" placeholder="Ghost Success Medium" />
                      <Input variant="ghost-success" size="lg" placeholder="Ghost Success Large" />
                      <Input variant="ghost-warning" size="sm" placeholder="Ghost Warning Small" />
                      <Input variant="ghost-warning" size="md" placeholder="Ghost Warning Medium" />
                      <Input variant="ghost-warning" size="lg" placeholder="Ghost Warning Large" />
                      <Input variant="ghost-info" size="sm" placeholder="Ghost Info Small" />
                      <Input variant="ghost-info" size="md" placeholder="Ghost Info Medium" />
                      <Input variant="ghost-info" size="lg" placeholder="Ghost Info Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Gradient Border Variants (21) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-pink-400">Gradient Border Variants (21)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="gradient-teal" size="sm" placeholder="Gradient Teal Small" />
                      <Input variant="gradient-teal" size="md" placeholder="Gradient Teal Medium" />
                      <Input variant="gradient-teal" size="lg" placeholder="Gradient Teal Large" />
                      <Input variant="gradient-blue" size="sm" placeholder="Gradient Blue Small" />
                      <Input variant="gradient-blue" size="md" placeholder="Gradient Blue Medium" />
                      <Input variant="gradient-blue" size="lg" placeholder="Gradient Blue Large" />
                      <Input variant="gradient-purple" size="sm" placeholder="Gradient Purple Small" />
                      <Input variant="gradient-purple" size="md" placeholder="Gradient Purple Medium" />
                      <Input variant="gradient-purple" size="lg" placeholder="Gradient Purple Large" />
                      <Input variant="gradient-pink" size="sm" placeholder="Gradient Pink Small" />
                      <Input variant="gradient-pink" size="md" placeholder="Gradient Pink Medium" />
                      <Input variant="gradient-pink" size="lg" placeholder="Gradient Pink Large" />
                      <Input variant="gradient-orange" size="sm" placeholder="Gradient Orange Small" />
                      <Input variant="gradient-orange" size="md" placeholder="Gradient Orange Medium" />
                      <Input variant="gradient-orange" size="lg" placeholder="Gradient Orange Large" />
                      <Input variant="gradient-red" size="sm" placeholder="Gradient Red Small" />
                      <Input variant="gradient-red" size="md" placeholder="Gradient Red Medium" />
                      <Input variant="gradient-red" size="lg" placeholder="Gradient Red Large" />
                      <Input variant="gradient-green" size="sm" placeholder="Gradient Green Small" />
                      <Input variant="gradient-green" size="md" placeholder="Gradient Green Medium" />
                      <Input variant="gradient-green" size="lg" placeholder="Gradient Green Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Special Effects (21) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-amber-400">Special Effects (21)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="glow" size="sm" placeholder="Glow Small" />
                      <Input variant="glow" size="md" placeholder="Glow Medium" />
                      <Input variant="glow" size="lg" placeholder="Glow Large" />
                      <Input variant="neon" size="sm" placeholder="Neon Small" />
                      <Input variant="neon" size="md" placeholder="Neon Medium" />
                      <Input variant="neon" size="lg" placeholder="Neon Large" />
                      <Input variant="cyber" size="sm" placeholder="Cyber Small" />
                      <Input variant="cyber" size="md" placeholder="Cyber Medium" />
                      <Input variant="cyber" size="lg" placeholder="Cyber Large" />
                      <Input variant="glass" size="sm" placeholder="Glass Small" />
                      <Input variant="glass" size="md" placeholder="Glass Medium" />
                      <Input variant="glass" size="lg" placeholder="Glass Large" />
                      <Input variant="frosted" size="sm" placeholder="Frosted Small" />
                      <Input variant="frosted" size="md" placeholder="Frosted Medium" />
                      <Input variant="frosted" size="lg" placeholder="Frosted Large" />
                      <Input variant="shimmer" size="sm" placeholder="Shimmer Small" />
                      <Input variant="shimmer" size="md" placeholder="Shimmer Medium" />
                      <Input variant="shimmer" size="lg" placeholder="Shimmer Large" />
                      <Input variant="pulse" size="sm" placeholder="Pulse Small" />
                      <Input variant="pulse" size="md" placeholder="Pulse Medium" />
                      <Input variant="pulse" size="lg" placeholder="Pulse Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Filled Variants (9) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-emerald-400">Filled Variants (9)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="filled" size="sm" placeholder="Filled Small" />
                      <Input variant="filled" size="md" placeholder="Filled Medium" />
                      <Input variant="filled" size="lg" placeholder="Filled Large" />
                      <Input variant="filled-light" size="sm" placeholder="Filled Light Small" />
                      <Input variant="filled-light" size="md" placeholder="Filled Light Medium" />
                      <Input variant="filled-light" size="lg" placeholder="Filled Light Large" />
                      <Input variant="filled-dark" size="sm" placeholder="Filled Dark Small" />
                      <Input variant="filled-dark" size="md" placeholder="Filled Dark Medium" />
                      <Input variant="filled-dark" size="lg" placeholder="Filled Dark Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Underline Variants (12) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-blue-400">Underline Variants (12)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="underline" size="sm" placeholder="Underline Small" />
                      <Input variant="underline" size="md" placeholder="Underline Medium" />
                      <Input variant="underline" size="lg" placeholder="Underline Large" />
                      <Input variant="underline-primary" size="sm" placeholder="Underline Primary Small" />
                      <Input variant="underline-primary" size="md" placeholder="Underline Primary Medium" />
                      <Input variant="underline-primary" size="lg" placeholder="Underline Primary Large" />
                      <Input variant="underline-danger" size="sm" placeholder="Underline Danger Small" />
                      <Input variant="underline-danger" size="md" placeholder="Underline Danger Medium" />
                      <Input variant="underline-danger" size="lg" placeholder="Underline Danger Large" />
                      <Input variant="underline-success" size="sm" placeholder="Underline Success Small" />
                      <Input variant="underline-success" size="md" placeholder="Underline Success Medium" />
                      <Input variant="underline-success" size="lg" placeholder="Underline Success Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* With Icons (24) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400">With Icons (24)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <Input variant="default" placeholder="Email" leftIcon={<Mail className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Username" leftIcon={<User className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Search" leftIcon={<Search className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Password" type="password" leftIcon={<Lock className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Phone" leftIcon={<Phone className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Credit Card" leftIcon={<CreditCard className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Location" leftIcon={<MapPin className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Website" leftIcon={<Globe className="w-4 h-4" />} />
                      <Input variant="primary" placeholder="Secure Email" leftIcon={<Shield className="w-4 h-4" />} />
                      <Input variant="primary" placeholder="@ Mention" leftIcon={<AtSign className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Show Password" rightIcon={<Eye className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Hide Password" rightIcon={<EyeOff className="w-4 h-4" />} />
                      <Input variant="success" placeholder="Verified" rightIcon={<Check className="w-4 h-4" />} />
                      <Input variant="danger" placeholder="Clear" rightIcon={<X className="w-4 h-4" />} />
                      <Input variant="default" placeholder="Select Date" rightIcon={<Calendar className="w-4 h-4" />} />
                      <Input variant="outline" placeholder="Email" leftIcon={<Mail className="w-4 h-4" />} />
                      <Input variant="outline-primary" placeholder="Search" leftIcon={<Search className="w-4 h-4" />} />
                      <Input variant="ghost" placeholder="Username" leftIcon={<User className="w-4 h-4" />} />
                      <Input variant="neon" placeholder="Cyber Input" leftIcon={<Shield className="w-4 h-4" />} />
                      <Input variant="glass" placeholder="Glass Input" leftIcon={<Globe className="w-4 h-4" />} />
                      <Input variant="gradient-teal" placeholder="Gradient with Icon" leftIcon={<Star className="w-4 h-4" />} />
                      <Input variant="gradient-purple" placeholder="Gradient Right Icon" rightIcon={<Heart className="w-4 h-4" />} />
                      <Input variant="glow" placeholder="Glowing Input" leftIcon={<Zap className="w-4 h-4" />} />
                      <Input variant="cyber" placeholder="Cyber Email" leftIcon={<Mail className="w-4 h-4" />} rightIcon={<Shield className="w-4 h-4" />} />
                    </div>
                  </div>

                  <Divider />

                  {/* With Labels & Helper Text (12) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-indigo-400">With Labels & Helper Text (12)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Input variant="default" label="Email Address" placeholder="you@example.com" helperText="We'll never share your email" />
                      <Input variant="primary" label="Username" placeholder="johndoe" helperText="Choose a unique username" required />
                      <Input variant="outline" label="Full Name" placeholder="John Doe" />
                      <Input variant="gradient-teal" label="Website URL" placeholder="https://example.com" helperText="Your personal or company website" />
                      <Input variant="glass" label="Bio" placeholder="Tell us about yourself" helperText="Maximum 160 characters" />
                      <Input variant="neon" label="API Key" placeholder="sk_test_..." helperText="Keep this secret" />
                      <Input variant="success" label="Verified Email" placeholder="verified@example.com" leftIcon={<Check className="w-4 h-4" />} />
                      <Input variant="filled" label="First Name" placeholder="John" required />
                      <Input variant="underline-primary" label="Company" placeholder="Acme Inc." />
                      <Input variant="outline-success" label="Phone Number" placeholder="+1 (555) 000-0000" leftIcon={<Phone className="w-4 h-4" />} />
                      <Input variant="cyber" label="Security Code" placeholder="Enter code" leftIcon={<Shield className="w-4 h-4" />} />
                      <Input variant="glow" label="Magic Link" placeholder="Enter your email" helperText="We'll send you a magic link" leftIcon={<Mail className="w-4 h-4" />} />
                    </div>
                  </div>

                  <Divider />

                  {/* With Errors (6) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-red-400">With Error States (6)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Input variant="default" label="Email" placeholder="invalid-email" error="Please enter a valid email address" />
                      <Input variant="primary" label="Password" type="password" placeholder="123" error="Password must be at least 8 characters" />
                      <Input variant="outline" label="Username" placeholder="ab" error="Username must be at least 3 characters" required />
                      <Input variant="gradient-teal" label="Phone" placeholder="123" error="Invalid phone number format" />
                      <Input variant="filled" label="Confirm Password" type="password" error="Passwords do not match" />
                      <Input variant="glass" label="API Key" placeholder="sk_" error="Invalid API key format" leftIcon={<Shield className="w-4 h-4" />} />
                    </div>
                  </div>

                  <Divider />

                  {/* Different Shapes (12) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-orange-400">Different Shapes (12)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="default" shape="rounded" placeholder="Rounded (Default)" />
                      <Input variant="default" shape="square" placeholder="Square Corners" />
                      <Input variant="default" shape="pill" placeholder="Pill Shape" />
                      <Input variant="primary" shape="rounded" placeholder="Primary Rounded" />
                      <Input variant="primary" shape="square" placeholder="Primary Square" />
                      <Input variant="primary" shape="pill" placeholder="Primary Pill" />
                      <Input variant="outline" shape="rounded" placeholder="Outline Rounded" />
                      <Input variant="outline" shape="square" placeholder="Outline Square" />
                      <Input variant="outline" shape="pill" placeholder="Outline Pill" />
                      <Input variant="gradient-teal" shape="rounded" placeholder="Gradient Rounded" />
                      <Input variant="gradient-teal" shape="square" placeholder="Gradient Square" />
                      <Input variant="gradient-teal" shape="pill" placeholder="Gradient Pill" />
                    </div>
                  </div>

                  <Divider />

                  {/* Different Sizes (15) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-yellow-400">All Sizes (15)</h4>
                    <div className="grid grid-cols-1 gap-3">
                      <Input variant="default" size="xs" placeholder="Extra Small (xs)" />
                      <Input variant="default" size="sm" placeholder="Small (sm)" />
                      <Input variant="default" size="md" placeholder="Medium (md)" />
                      <Input variant="default" size="lg" placeholder="Large (lg)" />
                      <Input variant="default" size="xl" placeholder="Extra Large (xl)" />
                      <Input variant="primary" size="xs" placeholder="Primary XS" />
                      <Input variant="primary" size="sm" placeholder="Primary SM" />
                      <Input variant="primary" size="md" placeholder="Primary MD" />
                      <Input variant="primary" size="lg" placeholder="Primary LG" />
                      <Input variant="primary" size="xl" placeholder="Primary XL" />
                      <Input variant="gradient-teal" size="xs" placeholder="Gradient XS" />
                      <Input variant="gradient-teal" size="sm" placeholder="Gradient SM" />
                      <Input variant="gradient-teal" size="md" placeholder="Gradient MD" />
                      <Input variant="gradient-teal" size="lg" placeholder="Gradient LG" />
                      <Input variant="gradient-teal" size="xl" placeholder="Gradient XL" />
                    </div>
                  </div>

                  <Divider />

                  {/* Utility Variants (12) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-gray-400">Utility Variants (12)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                      <Input variant="minimal" size="sm" placeholder="Minimal Small" />
                      <Input variant="minimal" size="md" placeholder="Minimal Medium" />
                      <Input variant="minimal" size="lg" placeholder="Minimal Large" />
                      <Input variant="elevated" size="sm" placeholder="Elevated Small" />
                      <Input variant="elevated" size="md" placeholder="Elevated Medium" />
                      <Input variant="elevated" size="lg" placeholder="Elevated Large" />
                      <Input variant="flat" size="sm" placeholder="Flat Small" />
                      <Input variant="flat" size="md" placeholder="Flat Medium" />
                      <Input variant="flat" size="lg" placeholder="Flat Large" />
                      <Input variant="bordered" size="sm" placeholder="Bordered Small" />
                      <Input variant="bordered" size="md" placeholder="Bordered Medium" />
                      <Input variant="bordered" size="lg" placeholder="Bordered Large" />
                    </div>
                  </div>

                  <Divider />

                  {/* Disabled States (5) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-gray-500">Disabled States (5)</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <Input variant="default" placeholder="Disabled Default" disabled />
                      <Input variant="primary" placeholder="Disabled Primary" disabled />
                      <Input variant="outline" placeholder="Disabled Outline" disabled />
                      <Input variant="gradient-teal" placeholder="Disabled Gradient" disabled />
                      <Input variant="filled" placeholder="Disabled Filled" leftIcon={<Mail className="w-4 h-4" />} disabled />
                    </div>
                  </div>

                  <Divider />

                  {/* Full Width (5) */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-semibold text-teal-400">Full Width (5)</h4>
                    <div className="space-y-3">
                      <Input variant="default" placeholder="Full Width Default" fullWidth />
                      <Input variant="primary" placeholder="Full Width Primary" fullWidth />
                      <Input variant="gradient-teal" placeholder="Full Width Gradient" fullWidth leftIcon={<Mail className="w-4 h-4" />} />
                      <Input variant="outline" placeholder="Full Width Outline" fullWidth />
                      <Input variant="neon" placeholder="Full Width Neon" fullWidth rightIcon={<Zap className="w-4 h-4" />} />
                    </div>
                  </div>

                </div>
              </Card>
              )}

              {/* Checkbox, Radio, Switch */}
              {(!activeComponent || activeComponent === 'checkbox-radio-switch') && (
              <Card id="checkbox-radio-switch">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Checkbox, Radio & Switch - 100+ Variants</h3>
                  <p className="text-sm text-gray-400">Comprehensive selection components with variants, sizes, and icons</p>
                </CardHeader>
                <div className="p-6 space-y-8">

                  {/* CHECKBOX SECTION */}
                  <div className="space-y-6">
                    <h3 className="text-lg font-semibold text-teal-400 border-b border-white/10 pb-2">Checkbox</h3>

                    {/* Checkbox Variants (10) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-cyan-400">Variants (10)</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <Checkbox variant="default" label="Default Checkbox" />
                        <Checkbox variant="primary" label="Primary Checkbox" />
                        <Checkbox variant="success" label="Success Checkbox" />
                        <Checkbox variant="warning" label="Warning Checkbox" />
                        <Checkbox variant="danger" label="Danger Checkbox" />
                        <Checkbox variant="info" label="Info Checkbox" />
                        <Checkbox variant="gradient-teal" label="Gradient Teal" />
                        <Checkbox variant="gradient-blue" label="Gradient Blue" />
                        <Checkbox variant="neon" label="Neon Effect" />
                        <Checkbox variant="glow" label="Glow Effect" />
                      </div>
                    </div>

                    <Divider />

                    {/* Checkbox Sizes (4) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-purple-400">Sizes (4)</h4>
                      <div className="space-y-2">
                        <Checkbox size="sm" label="Small Checkbox" />
                        <Checkbox size="md" label="Medium Checkbox (default)" />
                        <Checkbox size="lg" label="Large Checkbox" />
                        <Checkbox size="xl" label="Extra Large Checkbox" />
                      </div>
                    </div>

                    <Divider />

                    {/* Checkbox with Descriptions (4) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-emerald-400">With Descriptions (4)</h4>
                      <div className="space-y-3">
                        <Checkbox
                          variant="default"
                          label="Accept terms and conditions"
                          description="By checking this, you agree to our terms of service"
                          checked={checkboxChecked}
                          onChange={(e) => setCheckboxChecked(e.target.checked)}
                        />
                        <Checkbox
                          variant="success"
                          label="Subscribe to newsletter"
                          description="Get weekly updates about new features and updates"
                        />
                        <Checkbox
                          variant="warning"
                          label="Enable experimental features"
                          description="May cause unexpected behavior"
                        />
                        <Checkbox
                          variant="info"
                          label="Remember my choice"
                          description="Save this preference for future visits"
                        />
                      </div>
                    </div>

                    <Divider />

                    {/* Checkbox States (3) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-amber-400">States (3)</h4>
                      <div className="space-y-2">
                        <Checkbox label="Default State" />
                        <Checkbox label="Checked State" checked />
                        <Checkbox label="Disabled State" disabled />
                      </div>
                    </div>
                  </div>

                  <Divider className="my-8" />

                  {/* RADIO SECTION */}
                  <div className="space-y-6">
                    <h3 className="text-lg font-semibold text-teal-400 border-b border-white/10 pb-2">Radio</h3>

                    {/* Radio Variants (10) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-cyan-400">Variants (10)</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <Radio variant="default" label="Default Radio" name="variant" value="default" checked={radioValue === 'default'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="primary" label="Primary Radio" name="variant" value="primary" checked={radioValue === 'primary'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="success" label="Success Radio" name="variant" value="success" checked={radioValue === 'success'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="warning" label="Warning Radio" name="variant" value="warning" checked={radioValue === 'warning'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="danger" label="Danger Radio" name="variant" value="danger" checked={radioValue === 'danger'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="info" label="Info Radio" name="variant" value="info" checked={radioValue === 'info'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="gradient-teal" label="Gradient Teal" name="variant" value="grad-teal" checked={radioValue === 'grad-teal'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="gradient-blue" label="Gradient Blue" name="variant" value="grad-blue" checked={radioValue === 'grad-blue'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="neon" label="Neon Effect" name="variant" value="neon" checked={radioValue === 'neon'} onChange={(e) => setRadioValue(e.target.value)} />
                        <Radio variant="glow" label="Glow Effect" name="variant" value="glow" checked={radioValue === 'glow'} onChange={(e) => setRadioValue(e.target.value)} />
                      </div>
                    </div>

                    <Divider />

                    {/* Radio Sizes (4) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-purple-400">Sizes (4)</h4>
                      <div className="space-y-2">
                        <Radio size="sm" label="Small Radio" name="size" value="sm" />
                        <Radio size="md" label="Medium Radio (default)" name="size" value="md" />
                        <Radio size="lg" label="Large Radio" name="size" value="lg" />
                        <Radio size="xl" label="Extra Large Radio" name="size" value="xl" />
                      </div>
                    </div>

                    <Divider />

                    {/* Radio with Descriptions (3) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-emerald-400">With Descriptions (3)</h4>
                      <div className="space-y-3">
                        <Radio
                          variant="default"
                          label="Monthly Plan"
                          description="$9.99/month - Billed monthly"
                          name="plan"
                          value="monthly"
                        />
                        <Radio
                          variant="success"
                          label="Annual Plan"
                          description="$99/year - Save 17%"
                          name="plan"
                          value="annual"
                        />
                        <Radio
                          variant="info"
                          label="Lifetime Plan"
                          description="$299 - One time payment"
                          name="plan"
                          value="lifetime"
                        />
                      </div>
                    </div>
                  </div>

                  <Divider className="my-8" />

                  {/* SWITCH SECTION */}
                  <div className="space-y-6">
                    <h3 className="text-lg font-semibold text-teal-400 border-b border-white/10 pb-2">Switch</h3>

                    {/* Switch Variants (10) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-cyan-400">Variants (10)</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <Switch variant="default" label="Default Switch" checked={switch1} onChange={(e) => setSwitch1(e.target.checked)} />
                        <Switch variant="primary" label="Primary Switch" checked={switch2} onChange={(e) => setSwitch2(e.target.checked)} />
                        <Switch variant="success" label="Success Switch" checked={switch3} onChange={(e) => setSwitch3(e.target.checked)} />
                        <Switch variant="warning" label="Warning Switch" checked={switch4} onChange={(e) => setSwitch4(e.target.checked)} />
                        <Switch variant="danger" label="Danger Switch" checked={switch5} onChange={(e) => setSwitch5(e.target.checked)} />
                        <Switch variant="info" label="Info Switch" checked={switchChecked} onChange={(e) => setSwitchChecked(e.target.checked)} />
                        <Switch variant="gradient-teal" label="Gradient Teal" checked={true} />
                        <Switch variant="gradient-blue" label="Gradient Blue" checked={true} />
                        <Switch variant="neon" label="Neon Effect" checked={true} />
                        <Switch variant="glow" label="Glow Effect" checked={true} />
                      </div>
                    </div>

                    <Divider />

                    {/* Switch Sizes (4) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-purple-400">Sizes (4)</h4>
                      <div className="space-y-3">
                        <Switch size="sm" label="Small Switch" checked={true} />
                        <Switch size="md" label="Medium Switch (default)" checked={true} />
                        <Switch size="lg" label="Large Switch" checked={true} />
                        <Switch size="xl" label="Extra Large Switch" checked={true} />
                      </div>
                    </div>

                    <Divider />

                    {/* Switch with Icons (6) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-pink-400">With Icons (6)</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <Switch
                          variant="default"
                          label="Check / X Icons"
                          showIcons
                          checkedIcon={<Check className="w-full h-full" />}
                          uncheckedIcon={<X className="w-full h-full" />}
                          checked={switch1}
                          onChange={(e) => setSwitch1(e.target.checked)}
                        />
                        <Switch
                          variant="success"
                          label="Bell Notifications"
                          showIcons
                          checkedIcon={<Bell className="w-full h-full" />}
                          uncheckedIcon={<Bell className="w-full h-full" />}
                          checked={switch2}
                          onChange={(e) => setSwitch2(e.target.checked)}
                        />
                        <Switch
                          variant="info"
                          label="Heart / Star"
                          showIcons
                          checkedIcon={<Heart className="w-full h-full" />}
                          uncheckedIcon={<Star className="w-full h-full" />}
                          checked={switch3}
                          onChange={(e) => setSwitch3(e.target.checked)}
                        />
                        <Switch
                          variant="warning"
                          label="Zap Power"
                          size="lg"
                          showIcons
                          checkedIcon={<Zap className="w-full h-full" />}
                          uncheckedIcon={<Zap className="w-full h-full" />}
                          checked={switch4}
                          onChange={(e) => setSwitch4(e.target.checked)}
                        />
                        <Switch
                          variant="gradient-teal"
                          label="Shield Security"
                          size="lg"
                          showIcons
                          checkedIcon={<CheckCircle className="w-full h-full" />}
                          uncheckedIcon={<X className="w-full h-full" />}
                          checked={true}
                        />
                        <Switch
                          variant="neon"
                          label="Settings Gear"
                          size="lg"
                          showIcons
                          checkedIcon={<Settings className="w-full h-full" />}
                          uncheckedIcon={<Settings className="w-full h-full" />}
                          checked={true}
                        />
                      </div>
                    </div>

                    <Divider />

                    {/* Switch with Descriptions (4) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-emerald-400">With Descriptions (4)</h4>
                      <div className="space-y-3">
                        <Switch
                          variant="default"
                          label="Enable notifications"
                          description="Receive push notifications for new messages"
                          checked={switchChecked}
                          onChange={(e) => setSwitchChecked(e.target.checked)}
                        />
                        <Switch
                          variant="success"
                          label="Dark mode"
                          description="Toggle dark mode theme"
                          checked={true}
                        />
                        <Switch
                          variant="warning"
                          label="Beta features"
                          description="Enable experimental features (may be unstable)"
                          checked={false}
                        />
                        <Switch
                          variant="info"
                          label="Auto-save"
                          description="Automatically save your work every 5 minutes"
                          checked={true}
                        />
                      </div>
                    </div>

                    <Divider />

                    {/* Switch Label Positions (2) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-amber-400">Label Positions (2)</h4>
                      <div className="space-y-3">
                        <Switch
                          variant="default"
                          label="Label on right (default)"
                          labelPosition="right"
                          checked={true}
                        />
                        <Switch
                          variant="primary"
                          label="Label on left"
                          labelPosition="left"
                          checked={true}
                        />
                      </div>
                    </div>

                    <Divider />

                    {/* Switch States (3) */}
                    <div className="space-y-3">
                      <h4 className="text-sm font-semibold text-gray-400">States (3)</h4>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <Switch label="Unchecked" checked={false} />
                        <Switch label="Checked" checked={true} />
                        <Switch label="Disabled" checked={true} disabled />
                      </div>
                    </div>
                  </div>

                </div>
              </Card>
              )}

              {/* Textarea */}
              {(!activeComponent || activeComponent === 'textarea') && (
              <Card id="textarea">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Textarea</h3>
                  <p className="text-sm text-gray-400">24 variants × 4 sizes = 96+ combinations</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">BASIC VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <Textarea variant="default" placeholder="Default variant" rows={3} />
                      <Textarea variant="primary" placeholder="Primary variant" rows={3} />
                      <Textarea variant="success" placeholder="Success variant" rows={3} />
                      <Textarea variant="warning" placeholder="Warning variant" rows={3} />
                      <Textarea variant="danger" placeholder="Danger variant" rows={3} />
                      <Textarea variant="info" placeholder="Info variant" rows={3} />
                    </div>
                  </div>

                  {/* Outline Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">OUTLINE VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <Textarea variant="outline" placeholder="Outline" rows={3} />
                      <Textarea variant="outline-primary" placeholder="Outline Primary" rows={3} />
                      <Textarea variant="outline-success" placeholder="Outline Success" rows={3} />
                      <Textarea variant="outline-warning" placeholder="Outline Warning" rows={3} />
                      <Textarea variant="outline-danger" placeholder="Outline Danger" rows={3} />
                      <Textarea variant="outline-info" placeholder="Outline Info" rows={3} />
                    </div>
                  </div>

                  {/* Ghost Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-emerald-400 mb-4">GHOST VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Textarea variant="ghost" placeholder="Ghost" rows={3} />
                      <Textarea variant="ghost-primary" placeholder="Ghost Primary" rows={3} />
                      <Textarea variant="ghost-success" placeholder="Ghost Success" rows={3} />
                      <Textarea variant="ghost-warning" placeholder="Ghost Warning" rows={3} />
                      <Textarea variant="ghost-danger" placeholder="Ghost Danger" rows={3} />
                    </div>
                  </div>

                  {/* Gradient & Special Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">GRADIENT & SPECIAL EFFECTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <Textarea variant="gradient-teal" placeholder="Gradient Teal" rows={3} />
                      <Textarea variant="gradient-blue" placeholder="Gradient Blue" rows={3} />
                      <Textarea variant="gradient-purple" placeholder="Gradient Purple" rows={3} />
                      <Textarea variant="neon" placeholder="Neon Effect" rows={3} />
                      <Textarea variant="glow" placeholder="Glow Effect" rows={3} />
                      <Textarea variant="cyber" placeholder="Cyber Effect" rows={3} />
                    </div>
                  </div>

                  {/* Sizes */}
                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">SIZES</h4>
                    <div className="space-y-4">
                      <Textarea variant="primary" size="sm" placeholder="Small textarea" rows={2} />
                      <Textarea variant="primary" size="md" placeholder="Medium textarea" rows={3} />
                      <Textarea variant="primary" size="lg" placeholder="Large textarea" rows={4} />
                      <Textarea variant="primary" size="xl" placeholder="Extra large textarea" rows={5} />
                    </div>
                  </div>

                  {/* With Labels & Features */}
                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">WITH LABELS & FEATURES</h4>
                    <div className="space-y-4">
                      <Textarea
                        variant="default"
                        label="Message"
                        placeholder="Enter your message..."
                        helperText="Maximum 500 characters"
                        rows={4}
                      />
                      <Textarea
                        variant="primary"
                        label="Description"
                        placeholder="Enter description..."
                        value={textareaValue2}
                        onChange={(e) => setTextareaValue2(e.target.value)}
                        showCharCount
                        maxCharCount={200}
                        rows={4}
                      />
                      <Textarea
                        variant="danger"
                        label="Feedback"
                        placeholder="Enter feedback..."
                        error="This field is required"
                        rows={3}
                      />
                      <Textarea
                        variant="filled"
                        label="Notes"
                        placeholder="Filled variant with resize"
                        resize="both"
                        rows={3}
                      />
                    </div>
                  </div>

                  {/* Resize Options */}
                  <div>
                    <h4 className="text-sm font-semibold text-pink-400 mb-4">RESIZE OPTIONS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Textarea variant="default" placeholder="No resize" resize="none" rows={3} />
                      <Textarea variant="default" placeholder="Vertical resize" resize="vertical" rows={3} />
                      <Textarea variant="default" placeholder="Horizontal resize" resize="horizontal" rows={3} />
                      <Textarea variant="default" placeholder="Both directions" resize="both" rows={3} />
                    </div>
                  </div>

                  {/* States */}
                  <div>
                    <h4 className="text-sm font-semibold text-red-400 mb-4">STATES</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Textarea variant="default" placeholder="Normal state" rows={3} />
                      <Textarea variant="default" placeholder="Disabled state" disabled rows={3} />
                      <Textarea variant="default" placeholder="Required field" required label="Required Textarea" rows={3} />
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Slider */}
              {(!activeComponent || activeComponent === 'slider') && (
              <Card id="slider">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Slider</h3>
                  <p className="text-sm text-gray-400">10 variants × 4 sizes = 40+ combinations</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">BASIC VARIANTS ✨ NEW FIXED</h4>
                    <div className="space-y-6">
                      <Slider variant="default" label="Default (Uncontrolled)" defaultValue={50} showValue />
                      <Slider variant="primary" label="Primary (Uncontrolled)" defaultValue={75} showValue />
                      <Slider variant="success" label="Success (Uncontrolled)" defaultValue={30} showValue />
                      <Slider variant="warning" label="Warning (Uncontrolled)" defaultValue={60} showValue />
                      <Slider variant="danger" label="Danger (Uncontrolled)" defaultValue={40} showValue />
                      <Slider variant="info" label="Info (Uncontrolled)" defaultValue={45} showValue />
                    </div>
                  </div>

                  {/* Gradient Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">GRADIENT VARIANTS</h4>
                    <div className="space-y-6">
                      <Slider variant="gradient-teal" label="Gradient Teal" defaultValue={60} showValue />
                      <Slider variant="gradient-blue" label="Gradient Blue" defaultValue={70} showValue />
                      <Slider variant="gradient-purple" label="Gradient Purple" defaultValue={80} showValue />
                    </div>
                  </div>

                  {/* Special Effects */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">SPECIAL EFFECTS</h4>
                    <div className="space-y-6">
                      <Slider variant="neon" label="Neon Effect" defaultValue={55} showValue />
                      <Slider variant="glow" label="Glow Effect" defaultValue={65} showValue />
                    </div>
                  </div>

                  {/* Sizes */}
                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">SIZES</h4>
                    <div className="space-y-6">
                      <Slider variant="primary" size="sm" label="Small (sm)" defaultValue={40} showValue />
                      <Slider variant="primary" size="md" label="Medium (md)" defaultValue={50} showValue />
                      <Slider variant="primary" size="lg" label="Large (lg)" defaultValue={60} showValue />
                      <Slider variant="primary" size="xl" label="Extra Large (xl)" defaultValue={70} showValue />
                    </div>
                  </div>

                  {/* With Features */}
                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">WITH FEATURES</h4>
                    <div className="space-y-6">
                      <Slider
                        variant="default"
                        label="Volume Control"
                        defaultValue={75}
                        showValue
                        showMinMax
                        helperText="Adjust the system volume"
                      />
                      <Slider
                        variant="primary"
                        label="Brightness"
                        min={0}
                        max={100}
                        step={5}
                        defaultValue={80}
                        showValue
                        showMinMax
                        showSteps
                      />
                      <Slider
                        variant="success"
                        label="Price Range"
                        min={0}
                        max={1000}
                        step={50}
                        defaultValue={500}
                        showValue
                        showMinMax
                      />
                      <Slider
                        variant="warning"
                        label="Temperature"
                        min={-20}
                        max={120}
                        step={10}
                        defaultValue={25}
                        showValue
                        showMinMax
                      />
                    </div>
                  </div>

                  {/* States */}
                  <div>
                    <h4 className="text-sm font-semibold text-red-400 mb-4">STATES</h4>
                    <div className="space-y-6">
                      <Slider variant="default" label="Normal State" defaultValue={50} showValue />
                      <Slider variant="default" label="Disabled State" defaultValue={50} showValue disabled />
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* File Upload */}
              {(!activeComponent || activeComponent === 'file-upload') && (
              <Card id="file-upload">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">File Upload</h3>
                  <p className="text-sm text-gray-400">9 variants × 3 sizes = 27+ combinations</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">BASIC VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <FileUpload
                        variant="default"
                        accept="image/*"
                        multiple
                        onUpload={(files) => console.log('Default:', files)}
                      />
                      <FileUpload
                        variant="primary"
                        accept="image/*"
                        multiple
                        onUpload={(files) => console.log('Primary:', files)}
                      />
                      <FileUpload
                        variant="success"
                        accept="image/*"
                        multiple
                        onUpload={(files) => console.log('Success:', files)}
                      />
                      <FileUpload
                        variant="warning"
                        accept=".pdf,.doc,.docx"
                        onUpload={(files) => console.log('Warning:', files)}
                      />
                      <FileUpload
                        variant="danger"
                        accept="*"
                        onUpload={(files) => console.log('Danger:', files)}
                      />
                    </div>
                  </div>

                  {/* Gradient Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">GRADIENT VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <FileUpload
                        variant="gradient-teal"
                        accept="image/*"
                        onUpload={(files) => console.log('Gradient Teal:', files)}
                      />
                      <FileUpload
                        variant="gradient-blue"
                        accept="image/*"
                        onUpload={(files) => console.log('Gradient Blue:', files)}
                      />
                      <FileUpload
                        variant="gradient-purple"
                        accept="image/*"
                        onUpload={(files) => console.log('Gradient Purple:', files)}
                      />
                    </div>
                  </div>

                  {/* Utility Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">UTILITY VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <FileUpload
                        variant="minimal"
                        accept="image/*,.pdf"
                        onUpload={(files) => console.log('Minimal:', files)}
                      />
                      <FileUpload
                        variant="compact"
                        accept="image/*,.pdf"
                        onUpload={(files) => console.log('Compact:', files)}
                      />
                    </div>
                  </div>

                  {/* Sizes */}
                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">SIZES</h4>
                    <div className="space-y-4">
                      <FileUpload
                        variant="primary"
                        size="sm"
                        accept="image/*"
                        onUpload={(files) => console.log('Small:', files)}
                      />
                      <FileUpload
                        variant="primary"
                        size="md"
                        accept="image/*"
                        onUpload={(files) => console.log('Medium:', files)}
                      />
                      <FileUpload
                        variant="primary"
                        size="lg"
                        accept="image/*"
                        onUpload={(files) => console.log('Large:', files)}
                      />
                    </div>
                  </div>

                  {/* With Features */}
                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">WITH FEATURES</h4>
                    <div className="space-y-4">
                      <FileUpload
                        variant="default"
                        label="Profile Picture"
                        accept="image/*"
                        maxSize={2 * 1024 * 1024}
                        onUpload={(files) => console.log('Profile:', files)}
                        onError={(error) => console.error(error)}
                        helperText="Upload your profile picture (max 2MB)"
                      />
                      <FileUpload
                        variant="primary"
                        label="Documents"
                        accept=".pdf,.doc,.docx"
                        multiple
                        maxFiles={3}
                        maxSize={10 * 1024 * 1024}
                        onUpload={(files) => console.log('Documents:', files)}
                        helperText="Upload up to 3 documents (PDF, DOC, DOCX)"
                      />
                      <FileUpload
                        variant="success"
                        label="Image Gallery"
                        accept="image/*"
                        multiple
                        maxFiles={10}
                        showPreview
                        onUpload={(files) => console.log('Gallery:', files)}
                        helperText="Upload up to 10 images with preview"
                      />
                    </div>
                  </div>

                  {/* States */}
                  <div>
                    <h4 className="text-sm font-semibold text-red-400 mb-4">STATES</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <FileUpload
                        variant="default"
                        accept="image/*"
                        onUpload={(files) => console.log('Normal:', files)}
                      />
                      <FileUpload
                        variant="default"
                        accept="image/*"
                        disabled
                        onUpload={(files) => console.log('Disabled:', files)}
                      />
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Select */}
              {(!activeComponent || activeComponent === 'select') && (
              <Card id="select">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Select Dropdown</h3>
                  <p className="text-sm text-gray-400">24 variants × 4 sizes = 96+ combinations</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">BASIC VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <Select
                        variant="default"
                        placeholder="Select default..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' },
                          { value: '3', label: 'Option 3' }
                        ]}
                      />
                      <Select
                        variant="primary"
                        placeholder="Select primary..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' },
                          { value: '3', label: 'Option 3' }
                        ]}
                      />
                      <Select
                        variant="success"
                        placeholder="Select success..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' },
                          { value: '3', label: 'Option 3' }
                        ]}
                      />
                      <Select
                        variant="warning"
                        placeholder="Select warning..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' },
                          { value: '3', label: 'Option 3' }
                        ]}
                      />
                      <Select
                        variant="danger"
                        placeholder="Select danger..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' },
                          { value: '3', label: 'Option 3' }
                        ]}
                      />
                      <Select
                        variant="info"
                        placeholder="Select info..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' },
                          { value: '3', label: 'Option 3' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* Outline Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">OUTLINE VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <Select
                        variant="outline"
                        placeholder="Outline..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="outline-primary"
                        placeholder="Outline Primary..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="outline-success"
                        placeholder="Outline Success..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="outline-warning"
                        placeholder="Outline Warning..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="outline-danger"
                        placeholder="Outline Danger..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="outline-info"
                        placeholder="Outline Info..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* Ghost Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-emerald-400 mb-4">GHOST VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Select
                        variant="ghost"
                        placeholder="Ghost..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="ghost-primary"
                        placeholder="Ghost Primary..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="ghost-success"
                        placeholder="Ghost Success..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="ghost-warning"
                        placeholder="Ghost Warning..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="ghost-danger"
                        placeholder="Ghost Danger..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* Gradient & Special Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">GRADIENT & SPECIAL EFFECTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <Select
                        variant="gradient-teal"
                        placeholder="Gradient Teal..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="gradient-blue"
                        placeholder="Gradient Blue..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="gradient-purple"
                        placeholder="Gradient Purple..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="neon"
                        placeholder="Neon Effect..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="glow"
                        placeholder="Glow Effect..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="minimal"
                        placeholder="Minimal..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* Filled Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">FILLED VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <Select
                        variant="filled"
                        placeholder="Filled..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="filled-light"
                        placeholder="Filled Light..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="filled-dark"
                        placeholder="Filled Dark..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* Sizes */}
                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">SIZES</h4>
                    <div className="space-y-4">
                      <Select
                        variant="primary"
                        size="sm"
                        placeholder="Small select..."
                        options={[
                          { value: '1', label: 'Small Option 1' },
                          { value: '2', label: 'Small Option 2' }
                        ]}
                      />
                      <Select
                        variant="primary"
                        size="md"
                        placeholder="Medium select..."
                        options={[
                          { value: '1', label: 'Medium Option 1' },
                          { value: '2', label: 'Medium Option 2' }
                        ]}
                      />
                      <Select
                        variant="primary"
                        size="lg"
                        placeholder="Large select..."
                        options={[
                          { value: '1', label: 'Large Option 1' },
                          { value: '2', label: 'Large Option 2' }
                        ]}
                      />
                      <Select
                        variant="primary"
                        size="xl"
                        placeholder="Extra large select..."
                        options={[
                          { value: '1', label: 'Extra Large Option 1' },
                          { value: '2', label: 'Extra Large Option 2' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* With Labels & Features */}
                  <div>
                    <h4 className="text-sm font-semibold text-pink-400 mb-4">WITH LABELS & FEATURES</h4>
                    <div className="space-y-4">
                      <Select
                        variant="default"
                        label="Country"
                        value={selectValue}
                        onChange={(e) => setSelectValue(e.target.value)}
                        placeholder="Select a country..."
                        helperText="Choose your country of residence"
                        options={[
                          { value: 'us', label: 'United States' },
                          { value: 'uk', label: 'United Kingdom' },
                          { value: 'ca', label: 'Canada' },
                          { value: 'au', label: 'Australia' }
                        ]}
                      />
                      <Select
                        variant="danger"
                        label="Required Field"
                        error="This field is required"
                        required
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="success"
                        label="With Disabled Options"
                        options={[
                          { value: '1', label: 'Available Option' },
                          { value: '2', label: 'Disabled Option', disabled: true },
                          { value: '3', label: 'Another Available' }
                        ]}
                      />
                    </div>
                  </div>

                  {/* States */}
                  <div>
                    <h4 className="text-sm font-semibold text-red-400 mb-4">STATES</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Select
                        variant="default"
                        label="Normal State"
                        placeholder="Select..."
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                      <Select
                        variant="default"
                        label="Disabled State"
                        placeholder="Select..."
                        disabled
                        options={[
                          { value: '1', label: 'Option 1' },
                          { value: '2', label: 'Option 2' }
                        ]}
                      />
                    </div>
                  </div>
                </div>
              </Card>
              )}
            </div>
            )}

            {activeCategory === 'display' && (
            <div className="space-y-8">
              {/* Badges */}
              {(!activeComponent || activeComponent === 'badges') && (
              <Card id="badges">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Badges</h3>
                  <p className="text-sm text-gray-400">9 colors × 3 sizes</p>
                </CardHeader>
                <div className="p-6 space-y-4">
                  <div className="flex flex-wrap gap-2">
                    <Badge variant="default">Default</Badge>
                    <Badge variant="primary">Primary</Badge>
                    <Badge variant="success">Success</Badge>
                    <Badge variant="warning">Warning</Badge>
                    <Badge variant="danger">Danger</Badge>
                    <Badge variant="info">Info</Badge>
                    <Badge variant="purple">Purple</Badge>
                    <Badge variant="pink">Pink</Badge>
                    <Badge variant="orange">Orange</Badge>
                  </div>
                </div>
              </Card>
              )}

              {/* Stat Cards */}
              {(!activeComponent || activeComponent === 'stat-cards') && (
              <Card id="stat-cards">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Stat Cards</h3>
                  <p className="text-sm text-gray-400">12 variants × 14 colors × 4 sizes × 3 layouts</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">BASIC VARIANTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard title="Total Users" value="12,345" icon={User} color="teal" variant="default" />
                      <StatCard title="Revenue" value="$45.2K" icon={CreditCard} color="cyan" variant="gradient" />
                      <StatCard title="Active Sessions" value="1,234" icon={Zap} color="emerald" variant="bordered" />
                      <StatCard title="Downloads" value="89.5K" icon={Download} color="purple" variant="filled" />
                      <StatCard title="Server Load" value="45%" icon={Database} color="amber" variant="minimal" />
                      <StatCard title="Bandwidth" value="2.4 GB" icon={Globe} color="blue" variant="glass" />
                    </div>
                  </div>

                  {/* Special Effects */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">SPECIAL EFFECTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard title="Security Score" value="98%" icon={Shield} color="teal" variant="neon" />
                      <StatCard title="Uptime" value="99.9%" icon={CheckCircle} color="emerald" variant="glow" />
                      <StatCard title="Storage Used" value="856 GB" icon={Database} color="cyan" variant="solid" />
                      <StatCard title="API Calls" value="2.4M" icon={Send} color="purple" variant="outline" />
                      <StatCard title="Response Time" value="45ms" icon={Clock} color="amber" variant="ghost" />
                      <StatCard title="Error Rate" value="0.02%" icon={AlertCircle} color="red" variant="cyber" />
                    </div>
                  </div>

                  {/* With Trends */}
                  <div>
                    <h4 className="text-sm font-semibold text-emerald-400 mb-4">WITH TRENDS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard
                        title="New Users"
                        value="1,234"
                        icon={User}
                        color="teal"
                        trend={{ value: 12.5, isPositive: true }}
                      />
                      <StatCard
                        title="Sales"
                        value="$23.4K"
                        icon={ShoppingCart}
                        color="emerald"
                        trend={{ value: 8.2, isPositive: true }}
                      />
                      <StatCard
                        title="Bounce Rate"
                        value="24.3%"
                        icon={AlertCircle}
                        color="red"
                        variant="bordered"
                        trend={{ value: 5.1, isPositive: false }}
                      />
                      <StatCard
                        title="Page Views"
                        value="45.2K"
                        icon={Eye}
                        color="cyan"
                        variant="gradient"
                        trend={{ value: 15.8, isPositive: true }}
                      />
                      <StatCard
                        title="Conversion"
                        value="3.24%"
                        icon={CheckCircle}
                        color="emerald"
                        variant="filled"
                        trend={{ value: 2.1, isPositive: true }}
                      />
                      <StatCard
                        title="Cart Abandonment"
                        value="68.5%"
                        icon={ShoppingCart}
                        color="amber"
                        variant="glow"
                        trend={{ value: 4.3, isPositive: false }}
                      />
                    </div>
                  </div>

                  {/* With Progress */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">WITH PROGRESS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard
                        title="Disk Usage"
                        value="856 GB"
                        subtitle="of 1 TB"
                        icon={Database}
                        color="teal"
                        progress={85}
                      />
                      <StatCard
                        title="CPU Load"
                        value="45%"
                        subtitle="8 cores"
                        icon={Zap}
                        color="amber"
                        variant="bordered"
                        progress={45}
                      />
                      <StatCard
                        title="Memory"
                        value="12.4 GB"
                        subtitle="of 16 GB"
                        icon={Database}
                        color="cyan"
                        variant="gradient"
                        progress={77}
                      />
                      <StatCard
                        title="Goal Progress"
                        value="$24.5K"
                        subtitle="of $30K target"
                        icon={Star}
                        color="emerald"
                        variant="filled"
                        progress={82}
                      />
                      <StatCard
                        title="Course Completion"
                        value="67%"
                        subtitle="12 of 18 modules"
                        icon={CheckCircle}
                        color="purple"
                        variant="glow"
                        progress={67}
                      />
                      <StatCard
                        title="Battery Level"
                        value="34%"
                        subtitle="~2 hours left"
                        icon={Zap}
                        color="red"
                        variant="neon"
                        progress={34}
                      />
                    </div>
                  </div>

                  {/* With Progress Bar */}
                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">WITH PROGRESS BAR</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard
                        title="Storage"
                        value="72%"
                        icon={Database}
                        color="teal"
                        progress={72}
                        showProgress
                      />
                      <StatCard
                        title="Bandwidth"
                        value="45%"
                        icon={Globe}
                        color="cyan"
                        variant="bordered"
                        progress={45}
                        showProgress
                      />
                      <StatCard
                        title="RAM Usage"
                        value="88%"
                        icon={Zap}
                        color="amber"
                        variant="gradient"
                        progress={88}
                        showProgress
                      />
                    </div>
                  </div>

                  {/* With Badges */}
                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">WITH BADGES</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard
                        title="Active Users"
                        value="1,234"
                        icon={User}
                        color="teal"
                        badge="LIVE"
                      />
                      <StatCard
                        title="Premium Sales"
                        value="$12.4K"
                        icon={CreditCard}
                        color="purple"
                        variant="gradient"
                        badge="NEW"
                      />
                      <StatCard
                        title="Critical Alerts"
                        value="3"
                        icon={AlertCircle}
                        color="red"
                        variant="bordered"
                        badge="URGENT"
                      />
                    </div>
                  </div>

                  {/* Sizes */}
                  <div>
                    <h4 className="text-sm font-semibold text-pink-400 mb-4">SIZES</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                      <StatCard title="Small" value="1.2K" icon={Star} color="teal" size="sm" />
                      <StatCard title="Medium" value="3.4K" icon={Heart} color="cyan" size="md" />
                      <StatCard title="Large" value="5.6K" icon={Zap} color="purple" size="lg" />
                      <StatCard title="Extra Large" value="7.8K" icon={Star} color="emerald" size="xl" />
                    </div>
                  </div>

                  {/* Layouts */}
                  <div>
                    <h4 className="text-sm font-semibold text-indigo-400 mb-4">LAYOUTS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <StatCard
                        title="Horizontal"
                        value="1,234"
                        icon={User}
                        color="teal"
                        layout="horizontal"
                        subtitle="Default layout"
                      />
                      <StatCard
                        title="Vertical"
                        value="5,678"
                        icon={Database}
                        color="cyan"
                        variant="bordered"
                        layout="vertical"
                        subtitle="Stacked layout"
                      />
                      <StatCard
                        title="Compact"
                        value="9,012"
                        icon={Zap}
                        color="purple"
                        variant="gradient"
                        layout="compact"
                        subtitle="Space-efficient"
                      />
                    </div>
                  </div>

                  {/* Color Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-red-400 mb-4">ALL COLORS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                      <StatCard title="Teal" value="1.2K" icon={Star} color="teal" variant="gradient" />
                      <StatCard title="Cyan" value="2.3K" icon={Heart} color="cyan" variant="gradient" />
                      <StatCard title="Emerald" value="3.4K" icon={CheckCircle} color="emerald" variant="gradient" />
                      <StatCard title="Purple" value="4.5K" icon={Zap} color="purple" variant="gradient" />
                      <StatCard title="Amber" value="5.6K" icon={Star} color="amber" variant="gradient" />
                      <StatCard title="Blue" value="6.7K" icon={Info} color="blue" variant="gradient" />
                      <StatCard title="Red" value="7.8K" icon={AlertCircle} color="red" variant="gradient" />
                      <StatCard title="Pink" value="8.9K" icon={Heart} color="pink" variant="gradient" />
                      <StatCard title="Indigo" value="9.0K" icon={Star} color="indigo" variant="gradient" />
                    </div>
                  </div>

                  {/* Complex Examples */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">COMPLEX EXAMPLES</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <StatCard
                        title="Monthly Revenue"
                        value="$45,234"
                        subtitle="Last 30 days"
                        icon={CreditCard}
                        color="emerald"
                        variant="gradient"
                        trend={{ value: 12.5, isPositive: true }}
                        progress={78}
                        badge="GOAL"
                        size="lg"
                      />
                      <StatCard
                        title="Server Health"
                        value="98.5%"
                        subtitle="All systems operational"
                        icon={Shield}
                        color="teal"
                        variant="neon"
                        trend={{ value: 0.5, isPositive: true }}
                        progress={98}
                        size="lg"
                      />
                      <StatCard
                        title="User Engagement"
                        value="4.2/5"
                        subtitle="Based on 1,234 reviews"
                        icon={Star}
                        color="amber"
                        variant="glow"
                        trend={{ value: 8.3, isPositive: true }}
                        progress={84}
                        badge="EXCELLENT"
                        size="lg"
                      />
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Avatar */}
              {(!activeComponent || activeComponent === 'avatar') && (
              <Card id="avatar">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Avatar</h3>
                  <p className="text-sm text-gray-400">User profile display with status</p>
                </CardHeader>
                <div className="p-6 space-y-4">
                  <div className="flex flex-wrap items-center gap-4">
                    <Avatar size="xs" fallback="JD" />
                    <Avatar size="sm" fallback="JD" />
                    <Avatar size="md" fallback="JD" status="online" showStatus />
                    <Avatar size="lg" fallback="JD" status="away" showStatus />
                    <Avatar size="xl" fallback="JD" status="busy" showStatus />
                  </div>
                  <Divider label="Avatar Group" />
                  <AvatarGroup max={3}>
                    <Avatar fallback="JD" />
                    <Avatar fallback="SM" />
                    <Avatar fallback="AK" />
                    <Avatar fallback="BL" />
                    <Avatar fallback="CM" />
                  </AvatarGroup>
                </div>
              </Card>
              )}

              {/* Chips */}
              {(!activeComponent || activeComponent === 'chips') && (
              <Card id="chips">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Chips / Tags</h3>
                </CardHeader>
                <div className="p-6">
                  <ChipGroup>
                    <Chip label="React" variant="primary" onDelete={() => {}} />
                    <Chip label="TypeScript" variant="info" onDelete={() => {}} />
                    <Chip label="Tailwind" variant="success" onDelete={() => {}} />
                    <Chip label="Vite" variant="warning" />
                    <Chip label="Node.js" variant="default" />
                  </ChipGroup>
                </div>
              </Card>
              )}

              {/* Rating */}
              {(!activeComponent || activeComponent === 'rating') && (
              <Card id="rating">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Rating</h3>
                </CardHeader>
                <div className="p-6 space-y-4">
                  <Rating
                    value={ratingValue}
                    onChange={setRatingValue}
                    allowHalf
                    showValue
                  />
                  <Rating value={5} readonly />
                  <Rating value={3} icon="heart" />
                </div>
              </Card>
              )}

              {/* Timeline */}
              {(!activeComponent || activeComponent === 'timeline') && (
              <Card id="timeline">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Timeline</h3>
                </CardHeader>
                <div className="p-6">
                  <Timeline
                    items={[
                      {
                        title: 'Project Started',
                        description: 'Initial project setup and configuration',
                        time: '2 hours ago',
                        variant: 'success',
                        icon: <CheckCircle className="w-4 h-4" />
                      },
                      {
                        title: 'Development Phase',
                        description: 'Building core features and components',
                        time: '1 hour ago',
                        variant: 'default',
                        icon: <Zap className="w-4 h-4" />
                      },
                      {
                        title: 'Testing',
                        description: 'Running tests and quality assurance',
                        time: '30 minutes ago',
                        variant: 'warning',
                        icon: <AlertCircle className="w-4 h-4" />
                      }
                    ]}
                  />
                </div>
              </Card>
              )}

              {/* Code Block */}
              {(!activeComponent || activeComponent === 'code-block') && (
              <Card id="code-block">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Code Block</h3>
                </CardHeader>
                <div className="p-6">
                  <CodeBlock
                    title="example.tsx"
                    language="typescript"
                    code={`import { useState } from 'react';

export const Example = () => {
  const [count, setCount] = useState(0);

  return (
    <button onClick={() => setCount(count + 1)}>
      Count: {count}
    </button>
  );
};`}
                  />
                </div>
              </Card>
              )}

              {/* Kbd */}
              {(!activeComponent || activeComponent === 'kbd') && (
              <Card id="kbd">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Keyboard Shortcuts</h3>
                </CardHeader>
                <div className="p-6 space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-gray-300">Copy</span>
                    <KbdGroup>
                      <Kbd>⌘</Kbd>
                      <Kbd>C</Kbd>
                    </KbdGroup>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-300">Paste</span>
                    <KbdGroup>
                      <Kbd>⌘</Kbd>
                      <Kbd>V</Kbd>
                    </KbdGroup>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-300">Save</span>
                    <KbdGroup>
                      <Kbd>⌘</Kbd>
                      <Kbd>S</Kbd>
                    </KbdGroup>
                  </div>
                </div>
              </Card>
              )}

              {/* Copy Button */}
              {(!activeComponent || activeComponent === 'copy-button') && (
              <Card id="copy-button">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Copy Button</h3>
                </CardHeader>
                <div className="p-6 flex flex-wrap gap-3">
                  <CopyButton text="Hello World!" />
                  <CopyButton text="Code snippet" variant="outline" />
                  <CopyButton text="API Key" variant="ghost" showLabel={false} />
                </div>
              </Card>
              )}

              {/* Table */}
              {(!activeComponent || activeComponent === 'table') && (
              <Card id="table">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Data Table</h3>
                  <p className="text-sm text-gray-400">Full-featured data table</p>
                </CardHeader>
                <div className="p-6">
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableHeader>Name</TableHeader>
                        <TableHeader>Email</TableHeader>
                        <TableHeader>Role</TableHeader>
                        <TableHeader>Status</TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>John Doe</TableCell>
                        <TableCell>john@example.com</TableCell>
                        <TableCell>Admin</TableCell>
                        <TableCell>
                          <Badge variant="success">Active</Badge>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Jane Smith</TableCell>
                        <TableCell>jane@example.com</TableCell>
                        <TableCell>User</TableCell>
                        <TableCell>
                          <Badge variant="success">Active</Badge>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Bob Johnson</TableCell>
                        <TableCell>bob@example.com</TableCell>
                        <TableCell>User</TableCell>
                        <TableCell>
                          <Badge variant="warning">Pending</Badge>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Alice Williams</TableCell>
                        <TableCell>alice@example.com</TableCell>
                        <TableCell>Moderator</TableCell>
                        <TableCell>
                          <Badge variant="danger">Inactive</Badge>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </Card>
              )}

              {/* Stat Cards */}
              {(!activeComponent || activeComponent === 'stat-cards') && (
              <Card id="stat-cards">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Stat Cards</h3>
                  <p className="text-sm text-gray-400">Statistics cards with progress rings</p>
                </CardHeader>
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <StatCard
                    title="Total Users"
                    value="2,543"
                    trend={{ value: 12.5, isPositive: true }}
                    progress={75}
                    icon={User}
                    color="teal"
                  />
                  <StatCard
                    title="Revenue"
                    value="$45,231"
                    trend={{ value: 8.2, isPositive: true }}
                    progress={82}
                    icon={Zap}
                    color="cyan"
                  />
                  <StatCard
                    title="Exams Taken"
                    value="1,234"
                    trend={{ value: 3.1, isPositive: false }}
                    progress={45}
                    icon={CheckCircle}
                    color="purple"
                  />
                </div>
              </Card>
              )}
            </div>
            )}

            {activeCategory === 'feedback' && (
            <div className="space-y-8">
              {/* Alerts */}
              {(!activeComponent || activeComponent === 'alerts') && (
              <Card id="alerts">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Alerts</h3>
                  <p className="text-sm text-gray-400">4 types × 4 variants with dismissible & actions</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Basic Types */}
                  <div>
                    <h4 className="text-sm font-semibold text-emerald-400 mb-4">BASIC TYPES</h4>
                    <div className="space-y-3">
                      <Alert type="success" title="Success!">
                        Operation completed successfully. Your changes have been saved.
                      </Alert>
                      <Alert type="error" title="Error Occurred">
                        Something went wrong. Please try again or contact support.
                      </Alert>
                      <Alert type="warning" title="Warning">
                        Please review your input before continuing.
                      </Alert>
                      <Alert type="info" title="Information">
                        Here's some helpful information about this feature.
                      </Alert>
                    </div>
                  </div>

                  {/* Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">VARIANTS</h4>
                    <div className="space-y-3">
                      <Alert type="success" variant="default" title="Default Variant">
                        Subtle background with colored border and icon.
                      </Alert>
                      <Alert type="warning" variant="filled" title="Filled Variant">
                        Solid background color for high emphasis.
                      </Alert>
                      <Alert type="error" variant="outlined" title="Outlined Variant">
                        Transparent background with thick border.
                      </Alert>
                      <Alert type="info" variant="minimal" title="Minimal Variant">
                        Left border accent with transparent background.
                      </Alert>
                    </div>
                  </div>

                  {/* Dismissible */}
                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">DISMISSIBLE ALERTS</h4>
                    <div className="space-y-3">
                      <Alert type="success" title="Dismissible Success" dismissible onDismiss={() => {}}>
                        You can close this alert by clicking the X button.
                      </Alert>
                      <Alert type="info" variant="filled" title="Dismissible Filled" dismissible onDismiss={() => {}}>
                        This is a dismissible filled variant alert.
                      </Alert>
                    </div>
                  </div>

                  {/* With Actions */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">WITH ACTION BUTTONS</h4>
                    <div className="space-y-3">
                      <Alert
                        type="success"
                        title="Profile Updated"
                        action={{ label: "View Profile", onClick: () => {} }}
                      >
                        Your profile information has been updated successfully.
                      </Alert>
                      <Alert
                        type="warning"
                        variant="filled"
                        title="Confirm Action"
                        action={{ label: "Confirm", onClick: () => {} }}
                        dismissible
                        onDismiss={() => {}}
                      >
                        This action cannot be undone. Please review before confirming.
                      </Alert>
                      <Alert
                        type="error"
                        title="Update Available"
                        action={{ label: "Update Now", onClick: () => {} }}
                      >
                        A new version is available. Click to update your application.
                      </Alert>
                    </div>
                  </div>

                  {/* Custom Icons */}
                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">CUSTOM ICONS</h4>
                    <div className="space-y-3">
                      <Alert type="info" icon={Zap} title="Custom Icon">
                        This alert uses a custom Zap icon instead of the default.
                      </Alert>
                      <Alert type="success" icon={Star} variant="filled" title="Achievement Unlocked!">
                        You've earned a special badge for completing this tutorial.
                      </Alert>
                    </div>
                  </div>

                  {/* All Combinations */}
                  <div>
                    <h4 className="text-sm font-semibold text-pink-400 mb-4">ALL TYPE × VARIANT COMBINATIONS</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <Alert type="success" variant="default">Default success alert</Alert>
                      <Alert type="success" variant="filled">Filled success alert</Alert>
                      <Alert type="error" variant="outlined">Outlined error alert</Alert>
                      <Alert type="warning" variant="minimal">Minimal warning alert</Alert>
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Progress */}
              {(!activeComponent || activeComponent === 'progress') && (
              <Card id="progress">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Progress Indicators</h3>
                  <p className="text-sm text-gray-400">Progress bars & circular indicators with variants</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* Progress Bars */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">PROGRESS BARS</h4>
                    <div className="space-y-4">
                      <div>
                        <p className="text-xs text-gray-400 mb-2">Default with label</p>
                        <ProgressBar progress={75} variant="primary" showLabel />
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 mb-2">Success variant</p>
                        <ProgressBar progress={100} variant="success" showLabel />
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 mb-2">Warning variant</p>
                        <ProgressBar progress={45} variant="warning" showLabel />
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 mb-2">Danger variant</p>
                        <ProgressBar progress={25} variant="danger" showLabel />
                      </div>
                      <div>
                        <p className="text-xs text-gray-400 mb-2">Without label</p>
                        <ProgressBar progress={60} variant="primary" />
                      </div>
                    </div>
                  </div>

                  {/* Circular Progress */}
                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">CIRCULAR PROGRESS</h4>
                    <div className="flex flex-wrap items-center gap-6">
                      <div className="text-center">
                        <CircularProgress progress={25} size="sm" />
                        <p className="text-xs text-gray-400 mt-2">Small (25%)</p>
                      </div>
                      <div className="text-center">
                        <CircularProgress progress={50} size="md" />
                        <p className="text-xs text-gray-400 mt-2">Medium (50%)</p>
                      </div>
                      <div className="text-center">
                        <CircularProgress progress={75} size="lg" />
                        <p className="text-xs text-gray-400 mt-2">Large (75%)</p>
                      </div>
                      <div className="text-center">
                        <CircularProgress progress={100} size="xl" />
                        <p className="text-xs text-gray-400 mt-2">XL (100%)</p>
                      </div>
                    </div>
                  </div>

                  {/* Different Progress Values */}
                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">PROGRESS VALUES</h4>
                    <div className="space-y-3">
                      <ProgressBar progress={10} variant="primary" showLabel />
                      <ProgressBar progress={30} variant="primary" showLabel />
                      <ProgressBar progress={50} variant="primary" showLabel />
                      <ProgressBar progress={70} variant="primary" showLabel />
                      <ProgressBar progress={90} variant="primary" showLabel />
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Skeleton */}
              {(!activeComponent || activeComponent === 'skeleton') && (
              <Card id="skeleton">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Skeleton Loaders</h3>
                  <p className="text-sm text-gray-400">Content placeholders for loading states</p>
                </CardHeader>
                <div className="p-6 space-y-6">
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">BASIC SKELETONS</h4>
                    <div className="space-y-4">
                      <Skeleton className="h-4 w-3/4" />
                      <Skeleton className="h-4 w-1/2" />
                      <Skeleton className="h-4 w-5/6" />
                      <Skeleton className="h-8 w-32" />
                    </div>
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">SKELETON CARD</h4>
                    <SkeletonCard />
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">CUSTOM LAYOUTS</h4>
                    <div className="space-y-4">
                      {/* Avatar with text */}
                      <div className="flex items-center gap-4">
                        <Skeleton className="h-12 w-12 rounded-full" />
                        <div className="flex-1 space-y-2">
                          <Skeleton className="h-4 w-1/4" />
                          <Skeleton className="h-3 w-1/3" />
                        </div>
                      </div>

                      {/* Image with text */}
                      <div className="space-y-3">
                        <Skeleton className="h-48 w-full rounded-lg" />
                        <Skeleton className="h-4 w-2/3" />
                        <Skeleton className="h-4 w-1/2" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Empty State */}
              {(!activeComponent || activeComponent === 'empty-state') && (
              <Card id="empty-state">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Empty State</h3>
                  <p className="text-sm text-gray-400">7 3D variants × 3 sizes with animations</p>
                </CardHeader>
                <div className="p-6 space-y-8">
                  {/* 3D Variants */}
                  <div>
                    <h4 className="text-sm font-semibold text-teal-400 mb-4">3D ANIMATED VARIANTS</h4>
                    <div className="space-y-8">
                      <EmptyState
                        variant="3d"
                        title="No items found"
                        description="Get started by adding your first item to see it here."
                        actionLabel="Add Item"
                        secondaryActionLabel="Learn More"
                        onAction={() => {}}
                        onSecondaryAction={() => {}}
                      />
                    </div>
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-cyan-400 mb-4">SEARCH / NO RESULTS</h4>
                    <EmptyState
                      variant="search"
                      title="No results found"
                      description="Try adjusting your search or filter criteria to find what you're looking for."
                      actionLabel="Clear Filters"
                      secondaryActionLabel="View All"
                      onAction={() => {}}
                      onSecondaryAction={() => {}}
                    />
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-purple-400 mb-4">LOCKED / RESTRICTED</h4>
                    <EmptyState
                      variant="locked"
                      title="Access Restricted"
                      description="You don't have permission to view this content. Contact your administrator for access."
                      actionLabel="Request Access"
                      onAction={() => {}}
                    />
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-blue-400 mb-4">NO DATA / ANALYTICS</h4>
                    <EmptyState
                      variant="data"
                      title="No data available"
                      description="Start collecting data to see your analytics and insights here."
                      actionLabel="Start Collecting"
                      secondaryActionLabel="Import Data"
                      onAction={() => {}}
                      onSecondaryAction={() => {}}
                    />
                  </div>

                  <div>
                    <h4 className="text-sm font-semibold text-amber-400 mb-4">EMPTY FOLDER / FILES</h4>
                    <EmptyState
                      variant="folder"
                      title="No files yet"
                      description="Upload files to get started with your project."
                      actionLabel="Upload Files"
                      secondaryActionLabel="Browse Templates"
                      onAction={() => {}}
                      onSecondaryAction={() => {}}
                    />
                  </div>

                  {/* Sizes */}
                  <div>
                    <h4 className="text-sm font-semibold text-pink-400 mb-4">SIZES</h4>
                    <div className="space-y-6">
                      <EmptyState
                        variant="3d"
                        size="sm"
                        title="Small Size"
                        description="Compact empty state"
                        actionLabel="Action"
                        onAction={() => {}}
                      />
                      <EmptyState
                        variant="search"
                        size="md"
                        title="Medium Size (Default)"
                        description="Standard empty state size"
                        actionLabel="Action"
                        onAction={() => {}}
                      />
                      <EmptyState
                        variant="folder"
                        size="lg"
                        title="Large Size"
                        description="Prominent empty state for important sections"
                        actionLabel="Action"
                        onAction={() => {}}
                      />
                    </div>
                  </div>

                  {/* With Icons */}
                  <div>
                    <h4 className="text-sm font-semibold text-emerald-400 mb-4">WITH CUSTOM ICONS (MINIMAL VARIANT)</h4>
                    <div className="space-y-6">
                      <EmptyState
                        variant="minimal"
                        icon={Mail}
                        title="No messages"
                        description="Your inbox is empty"
                        actionLabel="Compose"
                        onAction={() => {}}
                      />
                      <EmptyState
                        variant="default"
                        icon={User}
                        title="No users"
                        description="Invite team members to get started"
                        actionLabel="Invite Users"
                        onAction={() => {}}
                      />
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Toast Notifications */}
              {(!activeComponent || activeComponent === 'toast') && (
              <Card id="toast">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Toast Notifications</h3>
                  <p className="text-sm text-gray-400">6 types × 6 variants × 4 sizes × 6 positions = 180+ combinations with 3D effects!</p>
                </CardHeader>
                <div className="p-6 space-y-6">
                  {/* Toast Types */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-medium text-gray-300">Toast Types</h4>
                    <div className="flex flex-wrap gap-3">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => addToast('success', 'Success!', 'Operation completed successfully')}
                      >
                        Success
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => addToast('error', 'Error!', 'Something went wrong')}
                      >
                        Error
                      </Button>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => addToast('warning', 'Warning!', 'Please review your input')}
                      >
                        Warning
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => addToast('info', 'Info', 'Here is some helpful information')}
                      >
                        Info
                      </Button>
                    </div>
                  </div>

                  <Divider />

                  {/* Toast Positions */}
                  <div className="space-y-3">
                    <h4 className="text-sm font-medium text-gray-300">Toast Position</h4>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setToastPosition('top-right')}
                      >
                        Top Right {toastPosition === 'top-right' && '✓'}
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setToastPosition('top-left')}
                      >
                        Top Left {toastPosition === 'top-left' && '✓'}
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setToastPosition('top-center')}
                      >
                        Top Center {toastPosition === 'top-center' && '✓'}
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setToastPosition('bottom-right')}
                      >
                        Bottom Right {toastPosition === 'bottom-right' && '✓'}
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setToastPosition('bottom-left')}
                      >
                        Bottom Left {toastPosition === 'bottom-left' && '✓'}
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => setToastPosition('bottom-center')}
                      >
                        Bottom Center {toastPosition === 'bottom-center' && '✓'}
                      </Button>
                    </div>
                    <div className="text-xs text-gray-500">
                      Current position: <span className="text-teal-400">{toastPosition}</span>
                    </div>
                  </div>
                </div>
              </Card>
              )}

              {/* Loading Screen */}
              {(!activeComponent || activeComponent === 'loading-screen') && (
              <Card id="loading-screen">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Loading Screen</h3>
                  <p className="text-sm text-gray-400">8 stunning 3D full-page loading animations</p>
                </CardHeader>
                <div className="p-6 space-y-4">
                  <div className="bg-amber-500/10 border border-amber-500/20 rounded-lg p-3 mb-4">
                    <p className="text-sm text-amber-400 flex items-center gap-2">
                      <Info className="w-4 h-4" />
                      Click any button below to see a full-page 3D loading animation (3 seconds)
                    </p>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('helix');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Helix
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('cyber');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Cyber
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('education');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Education
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('neural');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Neural
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('molecular');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Molecular
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('quantum');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Quantum
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('database');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Database
                    </Button>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => {
                        setLoadingVariant('matrix');
                        setTimeout(() => setLoadingVariant(null), 3000);
                      }}
                    >
                      <Zap className="w-4 h-4 mr-2" />
                      Matrix
                    </Button>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-4 text-xs text-gray-500">
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Helix:</strong> DNA-like spiral animation</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Cyber:</strong> Tech grid visualization</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Education:</strong> Book flip animation</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Neural:</strong> Network nodes</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Molecular:</strong> Atomic structure</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Quantum:</strong> Quantum particles</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Database:</strong> Data cylinders</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <CheckCircle className="w-3 h-3 mt-0.5 text-teal-400" />
                      <span><strong>Matrix:</strong> Matrix rain effect</span>
                    </div>
                  </div>
                </div>
              </Card>
              )}
            </div>
            )}

            {activeCategory === 'navigation' && (
            <div className="space-y-8">
              {/* Pagination */}
              {(!activeComponent || activeComponent === 'pagination') && (
              <Card id="pagination">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Pagination</h3>
                </CardHeader>
                <div className="p-6 flex justify-center">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={10}
                    onPageChange={setCurrentPage}
                  />
                </div>
              </Card>
              )}

              {/* Stepper */}
              {(!activeComponent || activeComponent === 'stepper') && (
              <Card id="stepper">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Stepper</h3>
                </CardHeader>
                <div className="p-6 space-y-6">
                  <Stepper
                    activeStep={stepperActive}
                    steps={[
                      { label: 'Personal Info', description: 'Enter your details' },
                      { label: 'Account Setup', description: 'Configure your account' },
                      { label: 'Verification', description: 'Verify your email' },
                      { label: 'Complete', description: 'All done!' }
                    ]}
                  />
                  <div className="flex justify-center gap-3">
                    <Button
                      size="sm"
                      disabled={stepperActive === 0}
                      onClick={() => setStepperActive(Math.max(0, stepperActive - 1))}
                    >
                      Previous
                    </Button>
                    <Button
                      size="sm"
                      disabled={stepperActive === 3}
                      onClick={() => setStepperActive(Math.min(3, stepperActive + 1))}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Card>
              )}

              {/* Divider */}
              {(!activeComponent || activeComponent === 'divider') && (
              <Card id="divider">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Divider</h3>
                </CardHeader>
                <div className="p-6 space-y-4">
                  <Divider />
                  <Divider label="OR" />
                  <Divider label="Continue" labelPosition="left" />
                  <Divider variant="dashed" />
                  <Divider variant="dotted" />
                </div>
              </Card>
              )}
            </div>
            )}

            {activeCategory === 'overlays' && (
            <div className="space-y-8">
              {/* Tooltip */}
              {(!activeComponent || activeComponent === 'tooltip') && (
              <Card id="tooltip">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Tooltip</h3>
                </CardHeader>
                <div className="p-6 flex flex-wrap gap-4">
                  <Tooltip content="This is a tooltip" position="top">
                    <Button>Hover me (Top)</Button>
                  </Tooltip>
                  <Tooltip content="This is a tooltip" position="bottom">
                    <Button>Hover me (Bottom)</Button>
                  </Tooltip>
                  <Tooltip content="This is a tooltip" position="left">
                    <Button>Hover me (Left)</Button>
                  </Tooltip>
                  <Tooltip content="This is a tooltip" position="right">
                    <Button>Hover me (Right)</Button>
                  </Tooltip>
                </div>
              </Card>
              )}

              {/* Dropdown */}
              {(!activeComponent || activeComponent === 'dropdown') && (
              <Card id="dropdown">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Dropdown</h3>
                </CardHeader>
                <div className="p-6">
                  <Dropdown>
                    <DropdownTrigger>
                      <Button>Open Menu</Button>
                    </DropdownTrigger>
                    <DropdownContent>
                      <DropdownItem onClick={() => {}}>
                        <Download className="w-4 h-4 mr-2" />
                        Download
                      </DropdownItem>
                      <DropdownItem onClick={() => {}}>
                        <Upload className="w-4 h-4 mr-2" />
                        Upload
                      </DropdownItem>
                      <DropdownSeparator />
                      <DropdownItem destructive onClick={() => {}}>
                        Delete
                      </DropdownItem>
                    </DropdownContent>
                  </Dropdown>
                </div>
              </Card>
              )}

              {/* Popover */}
              {(!activeComponent || activeComponent === 'popover') && (
              <Card id="popover">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Popover</h3>
                </CardHeader>
                <div className="p-6 flex gap-4">
                  <Popover
                    trigger={<Button>Click me</Button>}
                    content={
                      <div className="space-y-2">
                        <h4 className="font-semibold text-white">Popover Title</h4>
                        <p className="text-sm text-gray-400">
                          This is popover content with more information.
                        </p>
                      </div>
                    }
                  />
                  <Popover
                    trigger={<Button variant="outline">Hover me</Button>}
                    triggerOn="hover"
                    content={<p className="text-sm text-gray-300">Hover content!</p>}
                  />
                </div>
              </Card>
              )}

              {/* Drawer */}
              {(!activeComponent || activeComponent === 'drawer') && (
              <Card id="drawer">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Drawer</h3>
                </CardHeader>
                <div className="p-6 flex flex-wrap gap-3">
                  <Button onClick={() => setDrawerOpen(true)}>
                    Open Drawer
                  </Button>
                </div>
              </Card>
              )}

              {/* Accordion */}
              {(!activeComponent || activeComponent === 'accordion') && (
              <Card id="accordion">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Accordion</h3>
                </CardHeader>
                <div className="p-6">
                  <Accordion type="single" defaultValue="item-1">
                    <AccordionItem value="item-1">
                      <AccordionTrigger>What is this component?</AccordionTrigger>
                      <AccordionContent>
                        This is an accordion component that allows you to show and hide content.
                      </AccordionContent>
                    </AccordionItem>
                    <AccordionItem value="item-2">
                      <AccordionTrigger>How do I use it?</AccordionTrigger>
                      <AccordionContent>
                        Simply import the Accordion components and wrap your content.
                      </AccordionContent>
                    </AccordionItem>
                    <AccordionItem value="item-3">
                      <AccordionTrigger>Can I customize it?</AccordionTrigger>
                      <AccordionContent>
                        Yes! All components are fully customizable with props and className.
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
              </Card>
              )}

              {/* Modals */}
              {(!activeComponent || activeComponent === 'modals') && (
              <Card id="modals">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Modals</h3>
                  <p className="text-sm text-gray-400">Dialog windows with confirmation variants</p>
                </CardHeader>
                <div className="p-6 flex flex-wrap gap-3">
                  <Button onClick={() => setModalOpen(true)}>
                    Open Modal
                  </Button>
                  <Button variant="primary" onClick={() => setConfirmModalOpen(true)}>
                    Confirmation Modal
                  </Button>
                  <Button variant="danger" onClick={() => setDeleteModalOpen(true)}>
                    Delete Modal
                  </Button>
                </div>
              </Card>
              )}
            </div>
            )}

            {activeCategory === 'advanced' && (
            <div className="space-y-8">
              {/* Carousel */}
              {(!activeComponent || activeComponent === 'carousel') && (
              <Card id="carousel">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Carousel</h3>
                </CardHeader>
                <div className="p-6">
                  <Carousel autoPlay interval={4000}>
                    {[1, 2, 3, 4].map((num) => (
                      <div
                        key={num}
                        className="h-64 bg-gradient-to-br from-teal-500/20 to-cyan-500/20 rounded-lg flex items-center justify-center"
                      >
                        <h3 className="text-4xl font-bold text-white">Slide {num}</h3>
                      </div>
                    ))}
                  </Carousel>
                </div>
              </Card>
              )}

              {/* Cards Showcase */}
              {(!activeComponent || activeComponent === 'card-variants') && (
              <Card id="card-variants">
                <CardHeader>
                  <h3 className="text-xl font-semibold text-white">Card Variants</h3>
                </CardHeader>
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  <Card accent="teal">
                    <CardHeader>
                      <h4 className="font-semibold text-white">Teal Card</h4>
                    </CardHeader>
                    <div className="p-4 text-sm text-gray-400">
                      Card with teal accent
                    </div>
                  </Card>
                  <Card accent="purple">
                    <CardHeader>
                      <h4 className="font-semibold text-white">Purple Card</h4>
                    </CardHeader>
                    <div className="p-4 text-sm text-gray-400">
                      Card with purple accent
                    </div>
                  </Card>
                  <Card accent="cyan">
                    <CardHeader>
                      <h4 className="font-semibold text-white">Cyan Card</h4>
                    </CardHeader>
                    <div className="p-4 text-sm text-gray-400">
                      Card with cyan accent
                    </div>
                  </Card>
                </div>
              </Card>
              )}
            </div>
            )}

            {activeCategory === 'pages' && (
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-teal-500/10 to-cyan-500/10 border border-teal-500/20 rounded-lg p-6 mb-8">
                  <h2 className="text-2xl font-bold text-white mb-2">Full-Page Components</h2>
                  <p className="text-gray-400">
                    These components are designed to occupy the entire screen. Click "Open in New Tab" to view them.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* 404 Not Found */}
                  <Card className="hover:border-teal-500/30 transition-all">
                    <CardHeader>
                      <h3 className="text-xl font-semibold text-white">404 Not Found</h3>
                      <p className="text-sm text-gray-400 mt-2">
                        Error page displayed when a route doesn't exist
                      </p>
                    </CardHeader>
                    <div className="p-6 pt-0">
                      <Link to="/404" target="_blank">
                        <Button variant="outline" className="w-full">
                          <ExternalLink className="w-4 h-4 mr-2" />
                          View 404 Page
                        </Button>
                      </Link>
                    </div>
                  </Card>

                  {/* 403 Access Denied */}
                  <Card className="hover:border-teal-500/30 transition-all">
                    <CardHeader>
                      <h3 className="text-xl font-semibold text-white">403 Access Denied</h3>
                      <p className="text-sm text-gray-400 mt-2">
                        Error page displayed when user lacks permissions
                      </p>
                    </CardHeader>
                    <div className="p-6 pt-0">
                      <Link to="/access-denied" target="_blank">
                        <Button variant="outline" className="w-full">
                          <ExternalLink className="w-4 h-4 mr-2" />
                          View 403 Access Denied
                        </Button>
                      </Link>
                    </div>
                  </Card>

                  {/* Coming Soon */}
                  <Card className="hover:border-teal-500/30 transition-all">
                    <CardHeader>
                      <h3 className="text-xl font-semibold text-white">Coming Soon</h3>
                      <p className="text-sm text-gray-400 mt-2">
                        Full-featured coming soon page with countdown
                      </p>
                    </CardHeader>
                    <div className="p-6 pt-0">
                      <Link to="/coming-soon" target="_blank">
                        <Button variant="outline" className="w-full">
                          <ExternalLink className="w-4 h-4 mr-2" />
                          View Coming Soon Page
                        </Button>
                      </Link>
                    </div>
                  </Card>

                  {/* Coming Soon Simple */}
                  <Card className="hover:border-teal-500/30 transition-all">
                    <CardHeader>
                      <h3 className="text-xl font-semibold text-white">Coming Soon Simple</h3>
                      <p className="text-sm text-gray-400 mt-2">
                        Minimal coming soon page design
                      </p>
                    </CardHeader>
                    <div className="p-6 pt-0">
                      <Link to="/coming-soon-simple" target="_blank">
                        <Button variant="outline" className="w-full">
                          <ExternalLink className="w-4 h-4 mr-2" />
                          View Simple Coming Soon
                        </Button>
                      </Link>
                    </div>
                  </Card>
                </div>

                <div className="mt-8 bg-[#12121a]/60 backdrop-blur-sm border border-white/[0.06] rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-white mb-4">Loading Screen Animations</h3>
                  <p className="text-sm text-gray-400 mb-4">
                    8 stunning 3D loading animations available as full-page demos:
                  </p>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
                    <Link to="/loading/helix" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Helix
                      </Button>
                    </Link>
                    <Link to="/loading/cyber" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Cyber
                      </Button>
                    </Link>
                    <Link to="/loading/education" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Education
                      </Button>
                    </Link>
                    <Link to="/loading/neural" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Neural
                      </Button>
                    </Link>
                    <Link to="/loading/molecular" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Molecular
                      </Button>
                    </Link>
                    <Link to="/loading/quantum" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Quantum
                      </Button>
                    </Link>
                    <Link to="/loading/database" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Database
                      </Button>
                    </Link>
                    <Link to="/loading/matrix" target="_blank">
                      <Button variant="outline" size="sm" className="w-full">
                        <ExternalLink className="w-3 h-3 mr-1" />
                        Matrix
                      </Button>
                    </Link>
                  </div>
                  <div className="mt-4 pt-4 border-t border-white/[0.06]">
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => {
                        setActiveCategory('feedback');
                        scrollToComponent('loading-screen');
                      }}
                      className="w-full"
                    >
                      Or view demos in Feedback section →
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Drawer Component */}
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        title="Drawer Title"
        position="right"
      >
        <div className="space-y-4">
          <p className="text-gray-300">
            This is a drawer component. It can be positioned on any side of the screen.
          </p>
          <Button onClick={() => setDrawerOpen(false)}>Close Drawer</Button>
        </div>
      </Drawer>

      {/* Basic Modal */}
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Basic Modal"
      >
        <div className="space-y-4">
          <p className="text-gray-300">
            This is a basic modal component. It can contain any content you want.
          </p>
          <div className="flex justify-end gap-3">
            <Button variant="outline" onClick={() => setModalOpen(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={() => setModalOpen(false)}>
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => {
          setConfirmModalOpen(false);
        }}
        title="Confirm Action"
        message="Are you sure you want to proceed with this action? This cannot be undone."
      />

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={() => {
          setDeleteModalOpen(false);
        }}
        title="Delete Important Data"
        message="Are you sure you want to delete this item? This action is permanent and cannot be undone."
        variant="danger"
      />

      {/* Toast Container */}
      <ToastContainer
        position={toastPosition}
        toasts={toasts}
        onClose={(id) => setToasts(prev => prev.filter(t => t.id !== id))}
      />

      {/* Loading Screen Overlay */}
      {loadingVariant && (
        <LoadingScreen
          variant={loadingVariant as any}
          message={`Loading with ${loadingVariant} animation...`}
        />
      )}
    </div>
  );
};

export default NewComponentShowcase;
